import { useEffect, useRef, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import moment from 'moment';
import { debounce } from 'lodash';
import { Company, LineOfBusiness, ModalTitles } from 'utils/enums';
import { OBG_CPTCODES, MAMMOGRAM_EXCLUDED_CPTCODES, MAMMOGRAM_EXCLUDED_PROVIDER_KEY_LIST, EHIPA_DEFAULT_EXPIRY_DAYS, HEALTH_NET_LOBS, SCAN_COMPASS_IPAS, SCAN_COMPASS_CPT_CODES, SCAN_OPTS, SCAN_HPS, SCAN_SPEC_CODES } from 'utils/objects';
import { getDisplayCompanyId, showAuthSubmissionBlockingModalForAutoPaidClaims } from 'utils/helpers';

import {
  Select,
  Input,
  Radio,
  Button,
  Typography,
  Card,
  Checkbox,
  Tabs,
  Alert,
  Table,
  AutoComplete,
  List,
  Modal,
  Spin,
  Form,
  RadioChangeEvent,
  Space,
  Tooltip,
} from 'antd';
import { CloseOutlined, DeleteOutlined, ExclamationCircleOutlined, InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';
import { getBlobTypeFromFileExtension, handleDownload, toLetters } from 'utils/helpers';
import { riversideProximityCities } from 'utils/objects';
import constants from 'constants/index';

import {
  getProviderName,
  isPcp,
  isArcadia,
  getProviderByCity,
  getIpaAdvise,
  checkInitialFollowUp,
  acknowledgement,
  getCECProviders,
  getProviderByName,
  getProviderTermDate,
  checkProviderForAuthSubmission
} from 'store/authorization/provider/actions';
import { getPos } from 'store/authorization/pos/actions';
import { getDiagCodes } from 'store/authorization/diagCodes/actions';
import { enquireService } from 'store/authorization/enquireService/actions';
import { getSpecCodeList, postAuthHistory } from 'store/authorization/history/actions';
import { getReferType } from 'store/authorization/referType/actions';
import { getFacilities } from 'store/authorization/facilities/actions';
import { getAuthModifierCode } from 'store/authorization/modifierCode/actions';
import { getTempAuthNumber } from 'store/authorization/tempAuthNumber/actions';
import { submitConfirmedAuth } from 'store/authorization/submitConfirmedAuth/actions';
import { getExpiryDays } from 'store/authorization/expiryDays/actions';
import { checkMediCalCode, checkMediCalBenefitRestrict } from 'store/authorization/mediCal/actions';
import { isRequired as isAttachmentRequired, downloadAttachment, attachmentData, letterInfosData } from 'store/authorization/attach/actions';
import { get as getRuleCodes } from 'store/authorization/ruleCodes/actions';
import { getMemberConditionCodes } from 'store/eligibility/actions';
import { getOBCodes } from 'store/authorization/OBCodes/actions';
import { getPMTProv, postPainManagement, validatePulmNoduleAndPainClinic } from 'store/authorization/PMTProv/actions';
import { SearchAuthDuplicatesResult, validateDuplicateAuth } from 'store/authorization/duplicateAuth/actions';
import { getDownload as downloadResources, getDownloadableResources } from 'store/app/actions';
import { uploadFilestoAuth } from 'store/authorization/files/actions';
import { checkSpecialistAuthHistory, validateOPTOPH } from 'store/authorization/specialists/actions';
import { priorAuthValidation } from 'store/authorization/member/actions';
import { postCPSP} from 'store/authorization/cpsp/actions';
import { expireAuth } from 'store/authorization/extendAndModify/actions';
import { getPortalAuth } from 'store/authorization/portal/actions';
import { getAttachInfo } from 'store/authorization/attach/actions';

import FloatLabel from 'components/Common/FloatLabel';
import DatePickerLocalised from 'components/Common/DatePickerLocalised';
import CreateAuthDetailModal from "./CreateAuthDetailModal"

import { JCodeQuestionnaireModal, OBCodesModal, PainManagementModal, SpecialtyQuestionnaireModal, VendorProviderInputModal } from './Modals';
import styles from './CreateAuthorizationDetail.module.scss';
import DuplicateAuthsModal from '../DuplicateAuthsModal';

const { Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;
const { confirm } = Modal;
// APIs
/*

CREATE AUTHORIZATION PAGE
  (Init)
  - AuthHistory?providerKeyId=&companyId=APC&specialGroupId=
  - AuthMember?dateOfService=
  - AuthProvider/Provider?providerKeyId=168cec97-fdc2-4984-914b-005fb2c3a21d&companyId=APC
  - AuthProvider/GetIsPcp?providerKeyId=168cec97-fdc2-4984-914b-005fb2c3a21d&companyId=APC
  - AuthMember/POS?companyId=APC
  - AuthMember/ModifierCodes
  - AuthProvider/IsArcadia?providerKeyId=168cec97-fdc2-4984-914b-005fb2c3a21d&companyId=APC
  - AuthMember/TempAuthNumber?companyId=APC
  - AuthMember/MediCalCode?hpCode=CHPS
  - AuthMember/IsAttachmentRequired
  - AuthMember/RuleCodes?SetName=SHOW%20VACCINE%20FORM
  - AuthMember/RuleCodes?SetName=MRI%20CPT
  - AuthMember/RuleCodes?SetName=JCODE%20FORM%20CPT
  - AuthMember/ExpiryDays
  - App/CreateStatistic *
  - MemberSearch/ConditionCode

  (On Self-Referral Check)
  - AuthHistory?providerKeyId=168cec97-fdc2-4984-914b-005fb2c3a21d&companyId=APC&specialGroupId=

  (On Specialty Select)
  - AuthMember/GetProviderList

  (On Provider Select)
  - App/GetDownloadableResources?companyId=APC&materialType=FORM&measureCode=Auth

  (On Initial visit Check)
  - AuthMember/CheckInitialFollowUp?companyId=APC&membKeyId=09dd9a33-83e2-4067-b5cd-26008b0b00cd&provKeyId=402113c3-200d-4d3f-9751-e0ec9cc2ef33

  (On SurgeryCenter/OutPatient/Inpatient/TertiaryCare Select)
  - AuthMember/GetFacilities

  (On Diagnosis Input)
  - AuthMember/Diagnosis

  (On CPT Input)
  - AuthMember/EnquireService

  (On Download link click)
  - App/GetDownload?file=Forms\Questionnaires\MedicoRx%20Prescription%20Form%20(002).pdf

  (On Submit)
  - AuthMember/AuthCheckHealthPlanRules *
  - AuthMember/AuthCreateSubmitData

*/

const CreateAuthorizationDetail = ({ retroDos, setRetroDos, ...props }: any) => {
  const history = useHistory();
  const locationState: any = useLocation();
  const [LSMA, setLSMA] = useState(false);
  const [referralType, setReferralType] = useState<any>({});
  const [referringPhysician, setReferringPhysician] = useState<any>({});
  const [selfReferral, setSelfReferral] = useState(false);
  const [specialty, setSpecialty] = useState<any>({});
  const [location, setLocation] = useState('');
  const [provider, setProvider] = useState<any>({});

  const [inOutPatient, setInOutpatient] = useState('');
  const [pos, setPos] = useState<any>({});
  const [totalOBCare, setTotalOBCare] = useState(false);
  const [menstrualDate, setMenstrualDate] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [initialRequest, setInitialRequest] = useState(false);
  const [posType, setPosType] = useState('');
  const [facility, setFacility] = useState<any>({});
  const [secondOpinion, setSecondOpinion] = useState('');
  const [glaucoma, setGlaucoma] = useState('');
  const [noAutoApprove, setNoAutoApprove] = useState(false);

  const [cptCode, setCptCode] = useState<any>({});
  const [modifier, setModifier] = useState<any>({});
  const [additionalDiags, setAdditionalDiags] = useState<any>({});

  const [fullPosList, setFullPosList] = useState<any[]>([]);
  const [posList, setPosList] = useState<any[]>([]);
  const [specCodeList, setSpecCodeList] = useState<any[]>([]);
  const [referTypeList, setReferTypeList] = useState<any[]>([]);
  const [cityList, setCityList] = useState<any[]>([]);
  const [providerList, setProviderList] = useState<any[]>([]);
  const [facilityList, setFacilityList] = useState<any[]>([]);
  const [modifierCodes, setModifierCodes] = useState<any[]>([]);
  const [CECProviderList, setCECProviderList] = useState<any[]>([]);

  const [foundProviderList, setFoundProviderList] = useState<any[]>([]);
  const [diagCodeResult, setDiagCodeResult] = useState<any[]>([]);
  const [diagDataSource, setDiagDataSource] = useState<any[]>([]);
  const [CPTCodesResult, setCPTCodesResult] = useState<any[]>([]);
  const [cptDataSource, setCptDataSource] = useState<any[]>([]);
  const [tempAuthNumber, setTempAuthNumber] = useState<any>({});
  const [expiryDays, setExpiryDays] = useState(0);
  const [isPcp, setIsPcp] = useState(false);
  const [isArcadia, setIsArcadia] = useState(false);
  const [mediCalCheck, setMediCalCheck] = useState(false);
  const [attachmentRequired, setAttachmentRequired] = useState(false);
  const [vaccineRuleCodes, setVaccineRuleCodes] = useState<string[]>([]);
  const [mriCodes, setMriCodes] = useState<string[]>([]);
  const [jCodes, setJCodes] = useState<string[]>([]);
  const [conditionCodes, setConditionCodes] = useState<any[]>([]);
  const [OBCodeSelection, setOBCodeSelection] = useState('59400');
  const [attachmentList, setAttachmentList] = useState<any[]>([]);
  const [originalFileNames, setOriginalFileNames] = useState<any[]>([]);
  const [providerAcknowledgement, setProviderAcknowledgement] = useState('');

  const [form] = Form.useForm();

  const scrollToRef = useRef<null | HTMLDivElement>(null);
  const scrollToSpec = useRef<null | any>(null);
  const scrollToCity = useRef<null | any>(null);
  const providerAutoPopulated = useRef(false);
  const [retroDatePickerVisible, setRetroDatePickerVisible] = useState(false);
  const [prevRetro, setPrevRetro] = useState('');
  const [POSTab, setPOSTab] = useState('none');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rXFormVisible, setRXFormVisible] = useState(false);
  const [specialtyQuestionnaireModalVisible, setSpecialtyQuestionnaireModalVisible] = useState(false);
  const [specialtyQuestionnaireTitle, setSpecialtyQuestionnaireTitle] = useState('');
  const [OBCareVisible, setOBCareVisible] = useState(false);
  const [CPSPVisible, setCPSPVisible] = useState(false);
  const [OBCodesModalVisible, setOBCodesModalVisible] = useState(false);
  const [painManagementModalVisible, setPainManagementModalVisible] = useState(false);
  const [vendorProviderInputModalVisible, setVendorProviderInputModalVisible] = useState(false);
  const [IPAAdviseDisable, setIPAAdviseDisable] = useState(true);
  const [benefitRestricted, setBenefitRestricted] = useState(false);
  const [restrictedCPTList, setRestrictedCPTList] = useState<any[]>([]);
  const [RHUPMFlag, setRHUPMFlag] = useState(false);
  const [jCodeCount, setJCodeCount] = useState(0);
  const [jCodeQuestionnaireVisible, setJCodeQuestionnaireVisible] = useState(false);
  const [downloadableForms, setDownloadableForms] = useState<any[]>([]);
  const [showReferral, setShowReferral] = useState(false);
  const [CPSPCertifiedProvider, setCPSPCertifiedProvider] = useState(false);
  const [CPSP, setCPSP] = useState('');
  const [reminderText, setReminderText] = useState('');
  const [isClaimsAutoPaidForProvider, setIsClaimsAutoPaidForProvider] = useState(false);

  const [pmCpt, setPmCpt] = useState('');
  const [duplicateAuthModalDataSource, setDuplicateAuthModalDataSource] = useState<SearchAuthDuplicatesResult[]>([]);
  const [isDuplicateAuthModalVisible, setIsDuplicateAuthModalVisible] = useState(false);
  const [isIpaAdvisePresent, setIsIpaAdvisePresent] = useState(false);

  let currSpecCode = '';

  useEffect(() => {
    isLSMA();
    getProviderName();
    getExpiryDays();
    getPos();
    getSpecCodeList();
    getReferTypes();
    getAuthModifierCodes();
    getTempAuthNumber();
    getIsPcp();
    getIsArcadia();
    checkMediCalCode();
    isAttachmentRequired();
    getRuleCodes('SHOW%20VACCINE%20FORM', setVaccineRuleCodes);
    getRuleCodes('MRI%20CPT', setMriCodes);
    getRuleCodes('JCODE%20FORM%20CPT', setJCodes);
    setPrevRetro(retroDos);
    getDownloadableResources();
    if (props.authDetailState) {
      preSelectAttachments();
      preSelectNotifications();
    }
    setVendorProviderInputModalVisible(
      props.provider &&
      props.authMember &&
      HEALTH_NET_LOBS.includes(props.authMember.RmiHpCode) && // HP codes needs to be part of Health Net LOB
      props.provider.RmiFirstName === null // Vendor level records do not have first names
    );
    checkIpaAdviseIsPresent();
  }, []);

  useEffect(() => {
    // prevents back button from going to create auth detail
    if (!["/auth/create", "/auth/modify-auth"].includes(locationState.state?.previousPath)) {
      history.push("/auth/create");
    }

    window.addEventListener("popstate", backEvent);
    return () => {
      window.removeEventListener("popstate", backEvent);
    }

  },[]);

  useEffect(() => {
    LSMA && getCECProviders();
  }, [LSMA]);

  useEffect(() => {
    onRetroDateChange();
  }, [retroDos]);

  //This is to auto populate the specialty selection if it's coming from modify auth page
  useEffect(() => {

    if (providerList.length > 0 && props.authDetailState && !providerAutoPopulated.current) {
      setProvider(providerList.find(provider => provider.RmiProvKeyId === props.authDetailState.reqProvKeyId));
      providerAutoPopulated.current = true;
    }
  }, [providerList]);

  useEffect(() => {
    if (posList.length > 0 && specCodeList.length > 0 && props.authDetailState) {
      modifyAuthAutoPopulate();
    }
  }, [posList, specCodeList]);

  useEffect(() => {
    if (specialty && specialty.SpecCode && pos && props.provider.RmiProvKeyId == provider?.RmiProvKeyId) {
      okForAuthSubmission();
    }
  }, [pos, specialty, provider]);

  const backEvent = (e: any) => {
    if (e.state === null) {
      e.preventDefault();
      return false;
    }

    history.push('/auth/create');
    return props.triggerStartPage();
  }

  const isDuplicateAuthModalVisibleHandler = () => {
    setIsDuplicateAuthModalVisible(false);
  }

  const onSubmitAlertCallHandler = () => {
    onSubmitAlert();
  }

  //This is to auto populate the fields with the modify auth data page
  const modifyAuthAutoPopulate = () => {

    //auto populates POS
    const pos = posList.filter(x => x.RmiCode === props.authDetailState.pos);
    setPos(pos[0] || {});
    form.setFieldsValue({ pos: pos[0]?.Code });

    const specCode = props.authDetailState.referralSpecialty.match(/\((.*)\)/);
    const specCodeFound = JSON.stringify(specCodeList.find(x => x.SpecCode === specCode[1]));

    //auto populates select specialty dropdown
    if (specCodeFound) handleSpecCodeSelect(specCodeFound);


    const diags: any[] = [];
    const details: any[] = [];
    for (const diag of props.authDetailState.authDiagsData) {
      diags.push(
        {
          RmiDiagCode: diag.diagCode,
          RmiDiagDesc: diag.desc,
          RmiEffectDate: diag.RmiEffectDate,
          diagCode: diag.diagcodeText,
          RmiDiagFromDate: diag.RmiFromDate,
          RmiSpecificity: diag.RmiSpecificity
        }
      )
    }

    for (const detail of props.authDetailState.authDetailsData) {
      details.push({
        cptCode: detail.cpt,
        description: detail.desc,
        diagRef: detail.diagRef,
        modifier: detail.mod,
        units: detail.quantity,
        RmiPhCode: detail.RmiPhCode
      })
    }

    //auto populates Diagnosis and Cpt tables
    if (diags.length > 0) {
      setAdditionalDiags(diags[0]);
      form.setFieldsValue({ additionalDiags: diags[0].RmiDiagCode });
    }

    setDiagDataSource(diags);
    setCptDataSource(details);
  }

  const diagColumns = [
    {
      title: 'REMOVE',
      key: 'index',
      dataIndex: 'index',
      render: (_: string, __: any, index: number) => <a onClick={() => handleRemoveDiag(index)}><DeleteOutlined /></a>
    },
    {
      title: 'DIAGNOSIS CODE',
      key: 'RmiDiagCode',
      dataIndex: 'RmiDiagCode',
    },
    {
      title: 'DESCRIPTION',
      key: 'RmiDiagDesc',
      dataIndex: 'RmiDiagDesc',
    },
  ];

  const cptColumns = [
    {
      title: '',
      key: 'index',
      dataIndex: 'index',
      render: (_: string, record: any, index: number) => <a onClick={() => handleRemoveCpt(index, record)}><DeleteOutlined /></a>
    },
    {
      title: 'CPT CODE',
      key: 'cptCode',
      dataIndex: 'cptCode',
    },
    {
      title: 'DESCRIPTION',
      key: 'description',
      dataIndex: 'description',
    },
    {
      title: 'MODIFIER',
      key: 'modifier',
      dataIndex: 'modifier',
      render: (_: string, record: any, __: number) => record.modifier?.join(' ')
    },
    {
      title: 'DIAG REF',
      key: 'diagRef',
      dataIndex: 'diagRef',
    },
    {
      title: 'QTY',
      key: 'units',
      dataIndex: 'units',
    },
  ];

  const isLSMA = () => {
    sessionStorage.getItem('ipaGroup') === 'LSMA' && setLSMA(true);
  };

  /**
   *  API
   *  props.modifyAuthReferralBy is used for the new modify auth request flow (AM-1377) to set the referralBy Physician.
   *  Create auth flow from the auth search table does not pass "props.modifyAuthReferralBy" to this component that will use the provider dropdown instead.
   */
  const getProviderName = () => {

    const referralByKey = props.modifyAuthReferralBy ? props.modifyAuthReferralBy.RmiProvKeyId : props.provider.RmiProvKeyId;
    const companyId = props.modifyAuthReferralBy ? props.modifyAuthReferralBy.RmiCompanyId : props.provider.RmiCompanyId;

    return props.getProviderName(referralByKey, companyId)
    .then((response: any) => {
        if (response !== null) {
          setReferringPhysician(response[0]);

          if (response[0]?.RmiRevFullName?.toUpperCase().includes('CHINDRIS') ||
              response[0]?.RmiRevFullName?.toUpperCase().includes('SU KIN')) {
            setShowReferral(true);
          }

          if (props.provider.RmiProvKeyId) {
            props.checkSpecialistAuthHistory(props.authMember.RmiMembKeyId, props.provider.RmiProvKeyId)
              .then((response: boolean) => {
                if (response) {
                  setShowReferral(true);
                }
              })
          }
        } else {
          setReferringPhysician(props.provider);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getExpiryDays = () => {
    const { RmiCompanyId, RmiCategory } = props.authMember;
    const companyId = RmiCompanyId.toUpperCase();
    const lob = RmiCategory.toUpperCase();

    return props.getExpiryDays(companyId, lob)
      .then((response: number) => {
        setExpiryDays(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const duplicateAuthValidation = async () => {

    const CPTCodes = cptDataSource.map(value => value.cptCode);

    const validateDuplicateAuthPayload = {
      ReqProvKeyId: provider.RmiProvKeyId,
      RefProvKeyId: referringPhysician.RmiProvKeyId,
      CompanyId: props.authMember.RmiCompanyId,
      SpecCode: specialty?.SpecCode,
      MemberId: props.authMember.RmiMembId,
      CPTCodes,
      POS: pos.RmiCode
    };

    return props.validateDuplicateAuth(validateDuplicateAuthPayload)
      .then((response: SearchAuthDuplicatesResult[]) => {
        if (response?.length > 0) {
          if (response.length === 1 && response[0].authNo === props.previousAuthNumber) {
            setIsDuplicateAuthModalVisible(false);
            return false;
          }
          if (response.length > 1 && props.previousAuthNumber) {
            setDuplicateAuthModalDataSource(response.filter(item => item.authNo != props.previousAuthNumber));
          } else {
            setDuplicateAuthModalDataSource(response);
          }
          setIsDuplicateAuthModalVisible(true);
          return true;
        } else {
          setIsDuplicateAuthModalVisible(false);
          return false;
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const priorAuthValidation = () => {

    const payload = cptDataSource.map((cpt: any) => {
      return {
        RmiPOS: pos?.RmiCode,
        ICDCode: cpt.diagRef,
        SpecCode: specialty?.SpecCode,
        CPTCode: cpt.cptCode,
        RmiMembKeyId: props.authMember?.RmiMembKeyId,
        RmiHpCode: props.authMember?.RmiHpCode
      }
    });

    return props.priorAuthValidation(payload)
      .then((response: any[]) => {
        let listOfCodes = '';

        const uniqueCodes = response.reduce((unique, current) => {
          if(!unique.some((obj: any) => obj.RmiCPTCode === current.RmiCPTCode && obj.RmiICDCode === current.RmiICDCode)) {
            unique.push(current);
          }
          return unique;
        }, []);

        uniqueCodes.forEach((values: any, index: number, arr: any) => {
          let diagCodes = '';
          let cptCodes = '';
          if (values.RmiICDCode !== null) {
            diagCodes = `ICD Code: ${values.RmiICDCode}`;
          }
          if (values.RmiCPTCode !== null) {
            cptCodes = `CPT Code: ${values.RmiCPTCode}`;
          }
          listOfCodes += '(' + diagCodes  + (diagCodes !== '' ? ', ' : '') + cptCodes + ')';
          if (index !== arr.length - 1) {
            listOfCodes += ', ';
          }
        });

        if (response.length > 0) {
          Modal.warning({
            title: "Preventative Services",
            content: `Per Medicare and Medi-Cal, the service you are requesting does not require prior authorization.
                      Please submit your request directly to our claims department for payment. ${listOfCodes}`,
          });
          setIsSubmitting(false);
          return false;
        }
        if (isClaimsAutoPaidForProvider)
        {
          showAuthSubmissionBlockingModalForAutoPaidClaims();
          setIsSubmitting(false);
          return false;
        }
        return true;
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getPos = () => {
    return props.getPos(props.authMember.RmiCompanyId)
      .then((response: any[]) => {
        //hide POS 01 and 03 from PCPs
        if (props.provider && props.provider.RmiClass === 'P') {
          const filteredPOSList = response.filter(x => x.RmiCode !== '01' && x.RmiCode !== '03')
          setPosList(filteredPOSList);
          setFullPosList(filteredPOSList);
        } else {
          setPosList(response);
          setFullPosList(response);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getSpecCodeList = () => {
    return props.getSpecCodeList('', props.provider.RmiCompanyId, '')
      .then((response: any[]) => {

        const spec = response.map((currentElement: any, index: number, array: any[]) => {
          if (index === 0 || (index > 0 && array[index - 1].Description.substring(0, 1) !== currentElement.Description.substring(0, 1))) {
            return {...currentElement, anchorTag: '#specialty-' + currentElement.Description.substring(0, 1), anchorLetter: currentElement.Description.substring(0, 1)};
          } else {
            return { ...currentElement }
          }
        });

        setSpecCodeList(spec);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getReferTypes = () => {
    return props.getReferType('')
      .then((response: any[]) => {
        setReferTypeList(response);
        // set referral type depending on retro dos entry on previous page
        if (retroDos !== '') onSelectReferralType(JSON.stringify(response[1] || {}));
         else setReferralType(response[0]);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getAuthModifierCodes = () => {
    return props.getAuthModifierCode()
      .then((response: any[]) => {
        setModifierCodes(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getTempAuthNumber = () => {
    return props.getTempAuthNumber(props.authMember.RmiCompanyId)
      .then((response: any) => {
        setTempAuthNumber(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getIsPcp = () => {
    return props.isPcp(props.provider.RmiProvKeyId, props.provider.RmiCompanyId)
      .then((response: boolean) => {
        setIsPcp(response)
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getIsArcadia = () => {
    return props.isArcadia(props.provider.RmiProvKeyId, props.provider.RmiCompanyId)
      .then((response: boolean) => {
        setIsArcadia(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const checkMediCalCode = () => {
    return props.checkMediCalCode(props.authMember.RmiHpCode)
      .then((response: boolean) => {
        setMediCalCheck(response);
        getMemberConditionCodes(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const isAttachmentRequired = () => {
    return props.isAttachmentRequired()
      .then((response: string) => {
        setAttachmentRequired(response === 'Y' ? true : false);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getRuleCodes = (setName: string, setFunc: Function) => {
    return props.getRuleCodes(setName)
      .then((response: string[]) => {
        setFunc(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getDownloadableResources = () => {
    props.getDownloadableResources('Form', 'Auth', props.authMember.RmiCompanyId)
    .then((formData: any[]) => {
      setDownloadableForms(formData);
    }).catch((err: ErrorResponse) => {
      notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
    });
  };

  const downloadPDF = (filePath: string) => {
    props.downloadResources(filePath)
      .then((response: string) => {
        let blob = new Blob([response], {type: "application/pdf"});
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, "_blank", "");
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const downloadAttachment = (fileInfo: any) => {
    const downloadAttachmentParams = {
      AuthNo: fileInfo.authNo,
      CompanyId: fileInfo.companyId,
      FileLocation: fileInfo.fileLocation,
      FileName: fileInfo.fileName
    };
    props.downloadAttachment(downloadAttachmentParams)
    .then((response: any) => {
      handleDownload(response, fileInfo.fileMeta);
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
    });
  };

  const attachAttachment = (event: any) => {

    if (event.target.checked && attachmentList.find(x => x.name === event.target.value.fileMeta)) {
      return notifier.error('Please remove the duplicate file before attaching this file.');
    }

    if (event.target.checked && !attachmentList.find(x => x.name === event.target.value.fileMeta)) {
      const data = event.target.value;
      const downloadAttachmentParams = {
        AuthNo: data.authNo,
        CompanyId: data.companyId,
        FileLocation: data.folderLocation,
        FileName: data.fileName,
        IsModificationAuth: true
      };

      props.downloadAttachment(downloadAttachmentParams)
        .then((response: any) => {
          let ext = getBlobTypeFromFileExtension(data.fileName.split('.').pop()?.toLowerCase());
          let file = new File([response], data.fileMeta || data.fileName, {type: "application/" + ext});
          setAttachmentList((prevFiles) => [...prevFiles, file]);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
      });
    }

    if (!event.target.checked) {
      const newArray = [...attachmentList];
      setAttachmentList(newArray.filter(x => x.name !== event.target.value.fileMeta));
    }
  };

  const attachNotification = (event: any) => {

    const data = event.target.value;

    if (event.target.checked && attachmentList.find(x => x.name ===  data?.name || x.name ===  data?.fileName)) {
      return notifier.error('Please remove the duplicate file before attaching this file.');
    }

    if (event.target.checked && !attachmentList.find(x => x.name === data?.name || x.name === data?.fileName)) {
      var filePath = data.fileLocation === "AYCE" ? `${data.fileLocation}\\${data.fileName}` : `${data.fileLocation}${data.fileName}`;
      props.downloadResources(filePath)
        .then((response: any) => {
          let ext = getBlobTypeFromFileExtension(data.fileName.split('.').pop()?.toLowerCase());
          let file = new File([response], data.fileName, { type: "application/" + ext });
          setAttachmentList((prevFiles) => [...prevFiles, file]);
        })
        .catch((err: ErrorResponse) => {
          notifier.error(err.response.data.Message || 'Something went wrong, please contact a system administrator.');
        });
    }

    if (!event.target.checked) {
      const newArray = [...attachmentList];
      setAttachmentList(newArray.filter(x => x.name !== data.fileName));
    }
  };

  const getMemberConditionCodes = (mediCalCode: boolean) => {
    return props.getMemberConditionCodes(props.authMember.RmiCompanyId, props.authMember.RmiMembKeyId, sessionStorage.getItem('user_id'))
      .then((response: any[]) => {
        setConditionCodes(response);

        const age = moment(new Date()).diff(moment(props.authMember.RmiBirth), 'years');
        let symptomTreatment = form.getFieldValue('symptomTreatment') !== undefined ? form.getFieldValue('symptomTreatment') : '';
        const notDuplicateMessage = `Not a duplicate \nModification for approved Auth# ${props.previousAuthNumber}`;

        //if modify auth sent over a previousAuthNumber, then this is a modify auth instead of create auth
        if (props.previousAuthNumber && !symptomTreatment.includes(notDuplicateMessage)) {
          symptomTreatment = symptomTreatment + notDuplicateMessage;

          form.setFieldsValue({
            symptomTreatment: symptomTreatment
          });
        }

        if (age < 21 && mediCalCode) {
          // check for RC or CCS condition codes for Member
          const rc = response.filter(x => x.RmiCondition == 'RC' && (!x.RmiToDate || moment(x.RmiToDate) > moment()) );
          const ccs = response.filter(x => x.RmiCondition == 'CCS' && (!x.RmiToDate || moment(x.RmiToDate) > moment()) );
          if (ccs.length === 0 && rc.length === 0) { // if condition codes do not exist

            confirm({
              title: "Is this a possible California Children's Services condition?",
              content: "Please document this information in your member's medical records as this is required by the member's Health Plan.",
              type: "warning",
              maskClosable: false,
              okText: "Yes",
              cancelText: "No",
              width: "500px",
              onOk() {
                form.setFieldsValue({
                  symptomTreatment: symptomTreatment + 'Possible CCS.\n'
                });
              },
              onCancel() {
                form.setFieldsValue({
                  symptomTreatment: symptomTreatment + 'Not Possible CCS.\n'
                });
              }
            });

          }

          // if P class provider (PCP), age less than 18, with either RC or CCS info,
          // generate list and append to provider acknowledgements and symptoms & treatments
          if (props.provider.RmiClass == 'P' && ((age < 18 && rc.length !== 0) || ccs.length !== 0)) {
            let rcString = rc.map(item => {
              return <li>{item.RmiCondition}{(item.RmiSubCode ? '-' + item.RmiSubCode : '')}</li>;
            });

            let ccsString = ccs.map(item => {
              return <li>{item.RmiCondition}{(item.RmiSubCode ? '-' + item.RmiSubCode : '')}</li>;
            });

            Modal.warning({
              title: "California Children's Services Case",
              content: <><span>This member has a California Children's Services case and/or is under care at a Regional Center.  Follow up with the Regional Center and / or California Children's Services as needed. Please document this in the member's medical records as is required by health plans.  Here are the member's existing condition codes:</span>
                         <ul style={{ marginTop: '10px', textAlign: 'left' }}> {rcString} {ccsString}</ul></>
            });

            // Append provider acknowledgement to Auth Submission
            rc.length !== 0 && setProviderAcknowledgement(providerAcknowledgement.concat('RC'));
            ccs.length !== 0 && setProviderAcknowledgement(providerAcknowledgement.concat('CCS'));

            form.setFieldsValue({
              symptomTreatment: symptomTreatment + 'Acknowledged that member has a California Children\'s Services case and/or is under care at a Regional Center\n'
            });
          }
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getOBCodes = (cptCode: string) => {
    return props.getOBCodes(props.authMember.RmiCompanyId, cptCode)
      .then((response: any[]) => {
        addOBPackage(cptCode, response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  const getFacilities = (posCode: string) => {
    return props.getFacilities({
      "RmiCompanyId": props.authMember.RmiCompanyId,
      "SpecialGroupId": props.authMember.RmiSpecialGroupId,
      "POS": posCode,
      "HPCode": props.authMember.RmiHpCode,
      "Capitated": props.authMember.Capitated,
      "ReferByProvKeyId": referringPhysician.RmiProvKeyId,
    })
    .then((response: any[]) => {
      setFacilityList(response);
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    });
  };

  const checkMediCalRestriction = (cptCode: string) => {
    props.checkMediCalBenefitRestrict(cptCode)
      .then((response: any) => {
        if (response !== '') {
          setBenefitRestricted(true);
          setRestrictedCPTList((prev: any) => [...prev, response]);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getCECProviders = () => {
    props.getCECProviders(sessionStorage.getItem('user_id'), props.provider.RmiCompanyId)
      .then((response: any[]) => {
        setCECProviderList(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getProviderByCity = (searchData: any) => {
    props.getProviderByCity(searchData)
      .then((response: any[]) => {
        if (props.provider.RmiCompanyId?.toUpperCase() === Company.ALPHA &&
        referralType.RmiReferralType !== "RA" &&
        ((props.provider.RmiClass == "P" && ['ORS', 'RHU', 'PMT'].includes(currSpecCode)) ||
         (props.provider.RmiClass == "S" && ['ORS', 'RHU', 'PMT'].includes(currSpecCode) &&
         !['ORS', 'RHU', 'PMT'].includes(referringPhysician.RmiSpecCode))) && !riversideProximityCities.includes(props.authMember.RmiCity)) {
          // Set provider list here when it passes through ALPHA pain management logic
          const painManagementPayload = {
            PcpLocation: referringPhysician.RmiLocation ? referringPhysician.RmiLocation.Geography.WellKnownText : null,
            CompanyId: props.provider.RmiCompanyId,
            SpecCode: props.provider.RmiSpecCode,
            MembId: props.authMember.RmiMemberId,
          };
          //Provide full list to members outside of Riverside 20 mile radius
          props.postPainManagement(painManagementPayload)
            .then((pmResponse: any[]) => {
              setProviderList(response.concat(pmResponse));
              setFoundProviderList(response.concat(pmResponse));
              populateCityList(response.concat(pmResponse));
            });
        } else if (LSMA && searchData.SpecCode === 'DME' && props.authMember.RmiCountry === 'CVR') {
          // Add ExpressRX to provider list
          addExpressRXProvider(response);
        } else if (LSMA && (searchData.SpecCode === 'OPH' || searchData.SpecCode === 'OPT')) {
          // Handle CEC Providers
          filterCECProviders(response);
        } else {
          setProviderList(response);
          setFoundProviderList(response);
          populateCityList(response);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const populateCityList = (response: any[]) => {
    if (response.length == 0) {
      setCityList([]);
    } else {
      var cities: string[] = response.map(obj => obj.RmiCity).sort();
      var citiesSet: Set<string> = new Set(cities);
      cities= Array.from(citiesSet);

      const cityList = cities.filter(value => value).map((currentElement: any, index: number, array: string[]) => {
        if (index === 0 || (index > 0 && array[index - 1].substring(0, 1) !== currentElement.substring(0, 1))) {
          return { name: currentElement, anchorTag: '#city-' + currentElement.substring(0, 1), anchorLetter: currentElement.substring(0, 1) };
        } else {
          return { name: currentElement }
        }
      });

      setCityList(cityList);
    }
  };

  const filterCECProviders = (providerReponse: any[]) => {
    const provKeys = CECProviderList.map(x => x.RmiProvId);
    setProviderList([...providerReponse.filter(x => provKeys.includes(x.RmiProvId)).map(x => ({...x, RmiRevFullName: '[CEC] ' + x.RmiRevFullName })),
                      ...providerReponse.filter(x => !provKeys.includes(x.RmiProvId))]);
    setFoundProviderList([...providerReponse.filter(x => provKeys.includes(x.RmiProvId)).map(x => ({...x, RmiRevFullName: '[CEC] ' + x.RmiRevFullName })),
                          ...providerReponse.filter(x => !provKeys.includes(x.RmiProvId))]);
  };

  const addExpressRXProvider = (providerResponse: any[]) => {
    props.getProviderByName({
      providerName: "EXPRESS RX",
      companyId: referringPhysician.RmiCompanyId,
      userId: sessionStorage.getItem('user_id')
    }).then((expressRX: any[]) => {
      setProviderList([...expressRX, ...providerResponse]);
      setFoundProviderList([...expressRX, ...providerResponse]);
    }).catch((err: ErrorResponse) => {
      notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    })
  };

  const handleCPSPCertifiedProvider = async(e: RadioChangeEvent) => {
    setCPSPCertifiedProvider(e.target.value);
  }

  const handleCPSP = async(e: RadioChangeEvent) => {
    setCPSP(e.target.value);
  }
  // Initial Consult Control

  const handleInOutPatient = async (e: RadioChangeEvent) => {
    // NOTE: Leave this here for now

    // if ( await checkInitialFollowUp()) {
    //   if (cptDataSource.some(x => ['99201', '99202', '99203', '99204', '99205'].includes(x.cptCode))) {
    //     confirm({
    //       title: "Initial/Follow Up Code",
    //       content: "There are existing initial consult authorizations created for this member within the last 24 months. Would you still like to keep the inital follow up code?",
    //       type: "warning",
    //       maskClosable: false,
    //       okText: "Keep Initial Consult Code",
    //       cancelText: "Change to Follow-up Code",
    //       width: "500px",
    //       onOk() { },
    //       onCancel() {
    //         setCptDataSource(cptDataSource.map(x => {
    //           if (['99201', '99202', '99203', '99204', '99205'].includes(x.cptCode)) {
    //             return {
    //               ...x,
    //               RmiProcCode: initialFollowup[x.cptCode],
    //               cptCode: initialFollowup[x.cptCode],
    //               RmiDescr: 'OFFICE / OUTPATIENT VISIT',
    //               description: 'OFFICE / OUTPATIENT VISIT',
    //               ServiceCode: initialFollowup[x.cptCode] + ' OFFICE / OUTPATIENT VISIT',
    //             }
    //           }
    //           return x;
    //         }));
    //       }
    //     });
    //   }
    // } else {
    //   if (cptDataSource.some(x => ['99201', '99202', '99203', '99204', '99205'].includes(x.cptCode))) {
    //     notifier.error("Initial/Follow Up Code", "Initial visit code selected on auth, please double check.");
    //     return;
    //   }
    // }
    setInOutpatient(e.target.value);
  };

  // Self Referral Control

  const isSelfReferral = (e: CheckboxChangeEvent) => {
    const checked = e.target.checked;
    if (checked) {
      props.getSpecCodeList(props.provider.RmiProvKeyId, props.provider.RmiCompanyId, '')
      .then((response: any[]) => {
        setSpecCodeList(response);
        // clear specialty, provider, diag code list, and cpt codes
        setSpecialty({});
        setProvider({});
        setFoundProviderList([]);
        setProviderList([]);
        setDiagDataSource([]);
        setCptDataSource([]);
        form.resetFields(['cptCode', 'additionalDiags', 'units', 'provider', 'additionalModifiers']);

      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
    } else {
      getSpecCodeList();
    }

    setSelfReferral(checked);
  };

  // Referral Control

  const onSelectReferralType = (value: string) => {
    const type = JSON.parse(value);
    if (type.RmiReferralType === referralType.RmiReferralType) { // same entry
      setReferralType(type);
    } else if (type.RmiReferralType === 'RA') { // Retro
      confirm({
        title: 'Retro DOS Restrictions',
        content: `Retro DOS is restricted to ${expiryDays === 0 ? 90 :  expiryDays} days from today and must be within the selected member\'s eligibility range. If outside of member\'s eligibility range, please go back to the Member Search Page and select Retro DOS when selecting member.`,
        onOk() {
          setReferralType(type);
          setRetroDatePickerVisible(true);
          // clear cpt code list
          setCptDataSource([]);
          form.resetFields(['cptCode', 'additionalDiags', 'units', 'additionalModifiers']);
        },
        cancelButtonProps: { style: { display: 'none' } },
        maskClosable: false,
      });
    } else if (type.RmiReferralType === 'UR') { // Urgent
      confirm({
        title: 'Are you sure?',
        icon: <ExclamationCircleOutlined />,
        content: <>For urgent referrals, patients must require care <span style={{ color: 'red' }}>within the next 72 hours.</span> A delay in care would seriously jeopardize this patient's health. Please provide detailed explanation and documentation.</>,
        onOk() {
          // clear cpt code list if previous type was retro
          if (referralType.RmiReferralType === 'RA') {
            setCptDataSource([]);
            form.resetFields(['cptCode', 'additionalDiags', 'units', 'additionalModifiers']);
          }
          setReferralType(type);
          setRetroDos('');
          setRetroDatePickerVisible(false);
        } ,
        onCancel() {},
        maskClosable: false,
      });
    } else {
      setReferralType(type);
      setRetroDos('');
      setRetroDatePickerVisible(false);
    }
  }

  const onRetroDateChange = () => {
    if ((diagDataSource.length > 0 || cptDataSource.length > 0) && retroDos !== prevRetro) {
      confirm({
        title: 'Are you sure you want to change the Retro Date?',
        icon: <ExclamationCircleOutlined />,
        content: 'This will clear your current Diagnosis and CPT Code list. Continue?',
        onCancel() { setRetroDos(prevRetro) },
        onOk() {
           // clear diag code list, cpt code list
            setDiagDataSource([]);
            setCptDataSource([]);

            // set cpt field to empty
            form.resetFields(['cptCode', 'additionalDiags', 'units', 'additionalModifiers']);

            // set previous
            setPrevRetro(retroDos);
        },
        width: '500px',
      });
    }
  };

  const disabledDate = (current: moment.Moment) => {
    // Can not select days after today and before expiry days
    return current > moment().endOf('day') || current < moment().subtract(expiryDays, 'days').startOf('day');
  };

  // Diagnosis Control

  const handleDiagCodeSearch = (value: string) => {
    if (value.length < 3) return;
    let searchObject = {
      actionDate: moment().format('MM-DD-YYYY'),
      companyId: props.authMember.RmiCompanyId,
      diagCode: value,
      endDate: props.authMember.RmiEndDate,
      iCDVersion: constants.ICD_VERSION,
      startDate: props.authMember.RmiStartDate,
    }
    props.getDiagCodes(searchObject)
      .then((response: any) => {
        setDiagCodeResult(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const handleSelectDiagCode = (value: string, _: any) => {

    let diag = JSON.parse(value);
    form.setFieldsValue({ diagCodeText: diag.diagcode });

    // cannot have more than 10 diagnoses on the table
    if (diagDataSource.length >= 10) {
      notifier.error('Cannot have more than 10 diagnoses listed for 1 authorization.');
      return;
    }

    if (constants.ICD_VERSION === 10 && diag.RmiSpecificity === false) {
      // throw error
      notifier.error('This code is not billable or specific ICD-10-CM diag code. Please select a more specific diagnosis.');
      return;
    }

    for (let i = 0; i < diagDataSource.length; i++) {
      if (diagDataSource[i].RmiDiagCode === diag.RmiDiagCode) {
        // duplicate
        notifier.error('Duplicate Diagnosis Code exists. Please select a different diagnosis.');
        return;
      }
    }

    // Add to table
    setDiagDataSource((prev) => {
      form.setFieldsValue({ diagCodeText: '' });

      setAdditionalDiags(diag);
      form.setFieldsValue({ additionalDiags: diag.RmiDiagCode });

      return [...prev, diag];
    });

    setDiagCodeResult([]);

    // If provider also chosen, then set OB care checkbox to visible
    if (Object.keys(provider).length !== 0) {
      setOBCareVisible(true);
    }

  };

  const handleRemoveDiag = (index: number) => {

    // checks if a service line contains the diag reference code. Uses for loop to terminate early if needed.
    if (cptDataSource.length > 0) {
      for (let i = 0; i < cptDataSource.length; i++) {
        if (diagDataSource[index].RmiDiagCode === cptDataSource[i].diagRef) {
            notifier.error("Oops!", "There is a service line referring to this Diagnosis Code. \n Please remove the service line first.");
            return;
        }
      }
    }

    setDiagDataSource(prev => prev.filter((_, i) => i !== index));

    // set cpt field to empty
    form.resetFields(['cptCode', 'additionalDiags', 'units', 'additionalModifiers']);

    // if empty, set OB care checkbox to invisible
    if (diagDataSource.length === 1) {
      setOBCareVisible(false);
    }
  };

  // MediCalRX Check

  const checkMediCalRXExclusionRules = (item : any) => {
    if (mediCalCheck) {
      if (specialty) {
        if (specialty.SpecCode === 'OPH') {
          return false;
        } else if (specialty.SpecCode === 'U' && item.RmiProcCode.toUpperCase().trim() === 'J1580') {
          return false;
        } else if (item && item.MedicalRxExclusion) {
          return true;
        } else {
          return false;
        }
      } else {
        // error
        notifier.error('Please select a Specialty');
        return false;
      }
    } else {
      return false;
    }
  }

  // CPT Control

  const handleCPTCodeSearch = (value: string) => {
    if (value.length < 2) return;

    const phCode = !['ALPHA', 'CFC'].includes(props.provider.RmiCompanyId) &&
                    ['21', '22', '23', '24', '31', '32', '33', '51', '61', '62', '65'].includes(pos.RmiCode) ? 'H' : 'P';

    const searchObject = {
      CPTCode: value,
      RmiCompanyId: props.provider.RmiCompanyId,
      RmiHpCode: props.authMember.RmiHpCode,
      RmiStartDate: props.authMember.RmiStartDate,
      RmiEndDate: props.authMember.RmiEndDate,
      RmiSpecialtyProvKeyId: props.provider.RmiProvKeyId,
      RmiReferToProvKeyId: provider.RmiProvKeyId,
      RmiPhCode: phCode,
      RmiSex: props.authMember.RmiSex,
      SpecCode: provider.RmiSpecCode,
      InitialVisit: inOutPatient,
      RmiMembKeyId: props.authMember.RmiMembKeyId,
      ICDCode: additionalDiags.RmiDiagCode,
      IsRheumatologyPainManagement: RHUPMFlag,
      RmiPos: pos.RmiCode,
      RetroDate: retroDos ? moment(retroDos).format('YYYY-MM-DDTHH:mm:ss') : null
    };
    props.enquireService(searchObject)
      .then((response: any) => {
        const unique = response.filter( (ele: any, ind: number) => ind === response.findIndex( (elem: any) => elem.RmiProcCode === ele.RmiProcCode));
        setCPTCodesResult(unique);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const handleCPTCodeSelect = (value: string) => {
    const parsed = JSON.parse(value || '{}');
    let isCptExcluded = false;

    // warn on MRI code selection
    if (parsed && parsed.RmiProcCode && mriCodes.includes(parsed.RmiProcCode.trim())) {
      Modal.warning({
        title: "MRI Service Codes",
        content: "For MRI Service Codes we need a recent X-Ray or ultrasound report, symptoms, and duration of member's treatment in order to evaluate for medical necessity.",
      });
    }

    if (parsed && parsed.RmiProcCode && MAMMOGRAM_EXCLUDED_CPTCODES.includes(parsed.RmiProcCode.trim()) && pos.RmiCompanyId === 'CVIPA') {
      if (MAMMOGRAM_EXCLUDED_PROVIDER_KEY_LIST.includes(provider.RmiProvKeyId.toUpperCase()) ||
          ((pos.RmiCode === '21' || pos.RmiCode === '22') && MAMMOGRAM_EXCLUDED_PROVIDER_KEY_LIST.includes(facility.ProvKeyId.toUpperCase()))) {
            Modal.error({
              title: "Error!",
              content:  <>
                          Prior authorization is not required for mammogram screening/comprehensive diagnostic breast imaging services. Utilize the
                          Direct Referral form and schedule an appointment with one of the providers below: <br /><br />
                          Emanate Health <br />
                          Inter-Community Hospital<br />
                          210 San Bernardino Rd. Covina, 91723<br />
                          626 963 8411<br /><br />

                          Emanate Health<br />
                          Foothill Presbyterian Hospital<br />
                          250 S Grand Ave, Glendora 91741<br />
                          626 963 8411<br /><br />

                          If you have any questions, please call Member Services at (626) 282-0288.
                        </>,
              maskClosable: false,
            });
            isCptExcluded = true;
      } else {
        isCptExcluded = false;
      }
    } else  {
      isCptExcluded = false;
    }

    // MedicalRX Warning
    if (! isCptExcluded) {
      if (checkMediCalRXExclusionRules(parsed)) {
        if ((referralType.RmiReferralType === 'RA' && moment(retroDos).isSameOrAfter('2022-01-01', 'day')) || referralType.RmiReferralType !== 'RA') {
          Modal.error({
            title: "Medi-Cal RX Program",
            content:  <>
                        Requested services are covered under Medi-Cal Rx Program. <br />
                        Please choose one of the external links to submit your request: <br /> <br />
                        <a href="https://medi-calrx.dhcs.ca.gov/provider/"
                          target="_blank"><b>https://medi-calrx.dhcs.ca.gov/provider/</b></a>
                        <br />
                        <a href="https://account.covermymeds.com/" target="_blank"><b>https://account.covermymeds.com/</b></a>
                      </>,
            maskClosable: false,
          });
          isCptExcluded = true;
        }
      } else {
        isCptExcluded = false;
      }
    }

    if (isCptExcluded) {
      form.resetFields(['cptCode', 'units', 'additionalModifiers']);
      setModifier({});
      setCPTCodesResult([]);
    } else {
      setCptCode(parsed);
      form.setFieldsValue({ cptCode: parsed.ServiceCode ? parsed.ServiceCode : '' });
      form.setFieldsValue({ units: 1 });
    }
  };

  const addCptCode = async () => {
    form.validateFields(['cptCode', 'additionalDiags', 'units', 'additionalModifiers']).then(async values => {
      let data: any;
      let isDuplicateCPT = false;

      if (!cptCode.RmiProcCode) {
        notifier.error('Please select a CPT code from the dropdown list.');
        return;
      }

      if (cptCode.RmiProcCode && SCAN_COMPASS_CPT_CODES.includes(cptCode.RmiProcCode.trim())
          && SCAN_COMPASS_IPAS.includes(pos.RmiCompanyId) && SCAN_OPTS.includes(props.authMember.RmiOpt)
          && SCAN_SPEC_CODES.includes(specialty.SpecCode) && SCAN_HPS.includes(props.authMember.RmiHpCode)) {
        Modal.warning({
          title: "SCAN Compass",
          content: `The service you are requesting for initial visit does not require prior authorization.
                    If you are the servicing provider, please submit your Claims directly to our claims department for payment.`,
        });
        return;
      }

      //modifier 1
      const modifiers = [];
      modifiers.push(modifier.RmiModif);

      //additional modifiers 2, 3, 4
      if (values.additionalModifiers?.length > 0) {
        for (const additionalModifier of values.additionalModifiers) {
          if(additionalModifier) modifiers.push(JSON.parse(additionalModifier.modifier).RmiModif);
        }
      }

      data = {
        ...cptCode,
        cptCode: cptCode.RmiProcCode,
        description: cptCode.RmiDescr,
        modifier: modifiers,
        diagRef: additionalDiags.RmiDiagCode,
        units: values.units,
      }

      for (let i = 0; i < cptDataSource.length; i++) {
        if (cptDataSource[i].cptCode === data.cptCode) {
          // duplicate
          notifier.error('Duplicate CPT Code exists. Please select a different CPT.');
          isDuplicateCPT = true;
          return;
        }
      }

      // gender check
      if (['59400', '59410', '59610', '59510'].includes(data.cptCode) && (props.authMember.RmiSex === 'M')) {
        notifier.error('Gender mismatch. Please add a different CPT Code.');
        return;
      }

      // MediCalRX Restriction Check
      if (mediCalCheck) checkMediCalRestriction(data.cptCode);

      // Dermatology Code Package Additions
      if (provider && provider.RmiSpecCode === 'D' && ['99201', '99202', '99203'].includes(cptCode.RmiProcCode) && cptDataSource.filter((data) => ['11102', '99213'].includes(data.cptCode)).length === 0) {
        addDermatologyPackage(values.units);
      }

      // Urinology Code Package Additions
      const officeVisitCodes = ['99201', '99202', '99203', '99204', '99205', '99211', '99212', '99213', '99214', '99215'];
      if (provider && provider.RmiSpecCode === 'U' && officeVisitCodes.includes(cptCode.RmiProcCode) && cptDataSource.filter((data) => data.cptCode === '81000').length === 0) {
        addUrinologyPackage(values.units);
      }

      // Cardiology Code Package Additions
      if (provider && provider.RmiSpecCode === 'C' && officeVisitCodes.includes(cptCode.RmiProcCode) && cptDataSource.filter((data) => data.cptCode === '93000').length === 0) {
        addEKGPackage(values.units);
      }

      // JCode Questionnaire & Pharmacy Form
      if (jCodes && cptCode.RmiProcCode && jCodes.includes(cptCode.RmiProcCode.toUpperCase().trim())) {
        openJCodeQuestionnaire();
        setJCodeCount(jCodeCount + 1);
      }

      if (!isDuplicateCPT && OBG_CPTCODES.includes(cptCode.RmiProcCode)) {
        if (mediCalCheck) {
          handleOBCodeModalSubmit();
        } else {
          //just adds the base obgyn cpt code that will also trigger getting the facilities
          setTotalOBCare(false);
          getFacilities('21');
          Modal.warning({
            title: 'Clinical Info Needed',
            content: 'Clinical information is required in order to make determination. Please attach information to this authorization or enter a note that is 10 char or longer.',
          });
        }
      }
      setCptDataSource(prev => [...prev, data]); //appends base cptcode

      // clear entries
      setCptCode({});
      setModifier({});
      setCPTCodesResult([]);
      form.resetFields(['cptCode', 'units', 'modifier', 'additionalModifiers']);
    });
  };

  const handleRemoveCpt = (index: number, item: any) => {

    // remove from restricted cpt list if available
    if (mediCalCheck) setRestrictedCPTList(prev => prev.filter(x => x !== item.cptCode));
    if (restrictedCPTList.length === 0) setBenefitRestricted(false);

    // check if jCode
    if (jCodes && item.cptCode && jCodes.includes(item.cptCode.toUpperCase().trim())) setJCodeCount(jCodeCount - 1);

    setCptDataSource(prev => prev.filter((_, i) => i !== index));
  };

  // Specialty Control

  const handleSpecCodeSelect = (value: any, event?: React.MouseEvent) => {
    //prevent Href from re-routing URL and subsequently altering location.state object needed to get AuthMember
    event?.preventDefault();
    const specCode = JSON.parse(value);
    if (isIpaAdvisePresent) setIPAAdviseDisable(false);

    // use for members residing outside of Riverside with ALPHA pain management logic
    ['ORS', 'RHU', 'PMT'].includes(specCode.SpecCode) ? currSpecCode = specCode.SpecCode : currSpecCode = '';

    // get provider list
    const searchData = {
      "City": null,
      "SpecCode": specCode.SpecCode,
      "CompanyId": props.provider.RmiCompanyId,
      "SpecialGroupId": props.authMember.RmiSpecialGroupId,
      "HpCode": props.authMember.RmiHpCode,
      "RmiRegionCode": props.authMember.RmiRegionCode,
      "IsArcadiaProvider": isArcadia,
      "ProviderKeyId": selfReferral ? referringPhysician.RmiProvKeyId : '',
      "UserId": sessionStorage.getItem('user_id'),
      "PcpLocation": referringPhysician.RmiLocation ? referringPhysician.RmiLocation.Geography.WellKnownText : null,
      "ReferBySpec": referringPhysician.RmiSpecCode,
      "Capitated": props.authMember.Capitated,
      "PcpCity": props.provider.RmiCity,
      "RmiAge": moment(new Date()).diff(moment(props.authMember.RmiBirth), 'years'),
      "ReferByProvKeyId": referringPhysician.RmiProvKeyId,
      "MemberPcpKeyId": props.authMember.RmiProviderKeyId
    };

    getProviderByCity(searchData);

    setLocation('');
    setSpecialty(specCode);

    // Clear selected provider, diagnosis list, cpt code list, and selected cpt
    setProvider({});
    setDiagDataSource([]);
    setCptDataSource([]);
    setDiagCodeResult([]);
    setCPTCodesResult([]);
    form.resetFields(['cptCode', 'additionalDiags', 'units', 'provider', 'additionalModifiers']);


    // Pain Management, 36467 remove the old pain management logic for APC
    // Pain Management, 48879 remove the old pain management logic for ALPHA
    //if (['APC', 'AVISTA'].includes(props.provider.RmiCompanyId) &&
    if (['AVISTA'].includes(props.provider.RmiCompanyId) && //roll back the logic
        referralType.RmiReferralType !== "RA" && // not retroactive referral
        (['ORS', 'ORP', 'RHU', 'PMT', 'PMR'].includes(specCode.SpecCode))) {
          confirm({
            title: "Initial Visit or Follow Up",
            content: "Is this auth for an initial visit or a follow up?",
            type: "warning",
            okText: "Initial Visit",
            cancelText: "Follow Up",
            maskClosable: false,
            onOk() {
              openPainManagementModal();
            }
          });
    }

    //Ticket 29253 AHC Umi Auth Set-up
    if (sessionStorage.getItem('ipaGroup') === 'AHC' && specCode.SpecCode.toUpperCase() === 'LAB') {
      Modal.info(
        {
          title: "Laboratory Work",
          content: "All laboratory work must be performed at LabCorp.",
          type: "info",
          okText: "Confirm",
          maskClosable: false,
        });
    } else if (sessionStorage.getItem('ipaGroup') === 'AHC' && specCode.SpecCode.toUpperCase() === 'R') {
      Modal.info(
        {
          title: "Radiology Services",
          content: "All radiology services must be performed at UMI.",
          type: "info",
          okText: "Confirm",
          maskClosable: false,
        });
    }
  };


  const handleSpecialtySubmit = (values: any) => {
      // else if (['APC', 'AVISTA', 'GSGP'].includes(referringPhysician.RmiCompanyId)) {
      //   const selectedProviders = providerList.filter(x => x.RmiOphthalmologyTypes === null).sort((f, s) => f.Distance - s.Distance);
      //   setProviderList(selectedProviders);
      //   setFoundProviderList(selectedProviders);
      // }
    if (specialty.SpecCode === 'OPT') {
      const symptomTreatment = form.getFieldValue('symptomTreatment') !== undefined ? form.getFieldValue('symptomTreatment') : '';
      form.setFieldsValue({
        symptomTreatment: symptomTreatment + (values.benefitCheck ? 'This is for a Vision Screening and glasses. (would require benefit check)\n' : 'This is not for a Vision screening and glasses.\n') + (values.screening ? 'This is for a routine Vision Screening.\n' : 'This is not for a routine Vision screening.\n')
      });
      setNoAutoApprove(values.benefitCheck === 'Yes');
    }
    setSpecialtyQuestionnaireModalVisible(false);
  };

  // Pain Management Control

  const openPainManagementModal = () => {
    setPainManagementModalVisible(true);
  };

  const handlePainManagementSubmit = (values: any) => {
    const needPM = values.fracture;
    const olderThanFourteen = values.olderThanFourteen;

    if (isIpaAdvisePresent) setIPAAdviseDisable(needPM);

    const painManagementPayload = {
      PcpLocation: referringPhysician.RmiLocation ? referringPhysician.RmiLocation.Geography.WellKnownText : null,
      CompanyId: props.provider.RmiCompanyId,
      SpecCode: props.provider.RmiSpecCode,
      MembId: props.authMember.RmiMemberId,
    };

    props.postPainManagement(painManagementPayload)
      .then((pmResponse: any[]) => {

        let isExcludeOption = false;

        // Show all provider options affiliated to that specialty (Including MSK - Integrative)
        // combine providerList and pain management API
        // needPM && olderThanFourteen - Yes Yes
        // if questionnaire still shows up for members located outside of Riverside radius, populate list w/ all providers no matter the user response
        if ((props.provider.RmiCompanyId?.toUpperCase() === Company.ALPHA && !riversideProximityCities.includes(props.authMember.RmiCity?.toUpperCase()))
        || (needPM && olderThanFourteen)) {
          setProviderList(providerList.concat(pmResponse));
          setFoundProviderList(providerList.concat(pmResponse));
          setPainManagementModalVisible(false);
        }

        // Show MSK providers only (Integrative Physical Medicine Physicians)
        // use Pain Management API only
        // !fracture && olderThanFourteen - No Yes
        else if (!needPM && olderThanFourteen) {
          setProviderList(pmResponse);
          setFoundProviderList(pmResponse);
          setPainManagementModalVisible(false);
        }

        // Show all provider options affiliated to that specialty (excluding MSK - Integrative)
        // use providerList only but filter out Clinic providers on the providerList using the provider ID from Pain Management API
        // fracture && !olderThanFourteen - Yes No
        // !fracture && !olderThanFourteen - No No
        else {

          let excludeMSK = providerList;
          if (pmResponse.length > 0) {
            excludeMSK = providerList.filter(spec => !spec.RmiProvId?.includes(pmResponse[0]?.RmiProvId)); //exclude MSK Clinic providers
          }

          setProviderList(excludeMSK);
          setFoundProviderList(excludeMSK);
          setPainManagementModalVisible(false);
          isExcludeOption = true;
        }

        return isExcludeOption;
      })
      .then((isExcludeOption: any) => {

        if (!isExcludeOption) {
          const member = {
            'RmiCompanyId': props.authMember.RmiCompanyId,
            'RmiMemberKeyId': props.authMember.RmiMembKeyId,
            'RmiStartDate': props.authMember.RmiStartDate,
            'RmiEndDate': props.authMember.RmiEndDate,
            'UserId': sessionStorage.getItem('user_id'),
            'UserRole': sessionStorage.getItem('user_role'),
          };

          props.postAuthHistory(member)
            .then((response: any[]) => {
              const validAuthHistory = response.filter((x: any) => x.RmiAuthDate > moment('2020-09-01'));
              if (!validAuthHistory.length) setPmCpt("99203");
              else setPmCpt("99213");
            })
            .catch((err: ErrorResponse) => {
              notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
              setPainManagementModalVisible(false);
            });
        }
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      setPainManagementModalVisible(false);
    });

  };

  // JCode Control

  const openJCodeQuestionnaire = () => {
    setJCodeQuestionnaireVisible(true);
  };

  const handleJCodeQuestionnaireSubmit = (result: string) => {
    const symptomTreatment = form.getFieldValue('symptomTreatment') !== undefined ? form.getFieldValue('symptomTreatment') : '';
    form.setFieldsValue({ symptomTreatment: symptomTreatment + result + '\n' });
    setJCodeQuestionnaireVisible(false);
  };

  // Vendor Provider Input Modal Control
  const handleVendorProviderInputSubmit = (result: string) => {
    const symptomTreatment = form.getFieldValue('symptomTreatment') !== undefined ? form.getFieldValue('symptomTreatment') : '';
    form.setFieldsValue({ symptomTreatment: symptomTreatment + result });
    setVendorProviderInputModalVisible(false);
  };

  const handleCitySelect = (value: any, event?: React.MouseEvent) => {
    //prevent Href from re-routing URL and subsequently altering location.state object needed to get AuthMember
    event?.preventDefault();
    const filteredProviders = providerList.filter(p => p.RmiCity === value);
    setFoundProviderList(filteredProviders);
    setLocation(value);
  };

  const scrollToCityName = (letter: any) => {
    scrollToCity.current = document.getElementById('#city-' + letter);

    if (scrollToCity.current === null) return;
    scrollToCity.current!.scrollIntoView({
      block: 'nearest',
      inline: 'start'
    });
  }

  const scrollToSpecialty = (letter: any) => {
    scrollToSpec.current = document.getElementById('#specialty-' + letter);

    if (scrollToSpec.current === null) return;
    scrollToSpec.current!.scrollIntoView({
      block: 'nearest',
      inline: 'start'
    });
  }

  const handleProviderSearch = (keyword: string) => {

    if (keyword !== '') {
      const results = providerList.filter((item) => {
        return item.RmiRevFullName.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
      });
      setFoundProviderList(results);
    } else {
      setFoundProviderList(providerList);
    }

    setProvider(keyword);
    form.setFieldsValue({ provider: keyword });
  };

  const handleProviderSelect = (item: any) => {
    const companyId = props.authMember.RmiCompanyId.toUpperCase();

    return props.getProviderTermDate(sessionStorage.getItem('user_id'), item.RmiProvKeyId, companyId)
      .then((response: any) => {
        let providerTermDate =  response;
        let termYear = moment(providerTermDate).year();
        if (providerTermDate !== null && termYear < 2999) {
          confirm({
            title: 'Are you sure?',
            icon: <ExclamationCircleOutlined />,
            content: <>The Provider you have selected has termination date of {moment(providerTermDate).format('MM/DD/YYYY')}. To prevent any delays in care, please consider redirection. For any questions/concerns, please contact UM Customer Service 626-282-0288. </>,
            onOk() {
              performProviderSelectOperations(item);
            } ,
            onCancel() {},
            maskClosable: false,
          });
        } else {
          performProviderSelectOperations(item);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
      })
  };

  const performProviderSelectOperations = (item: any) => {
    const selectedProvider = { ...item, RmiSpecCode: !!specialty.SpecCode ? specialty.SpecCode : provider.RmiProvSpecialties };

    setProvider(selectedProvider);
    form.setFieldsValue({ provider: item.RmiRevFullName });
    setLocation(item.RmiCity);

    if (item.RmiRevFullName.toLowerCase().includes('medicorx specialty') && ['ADV', 'AHC', 'APC', 'GOM', 'AVISTA', 'CVIPA', 'BAIPA', 'GSGP'].includes(referringPhysician.RmiCompanyId)) {
      setRXFormVisible(true);
    } else setRXFormVisible(false);

    if (scrollToRef === null) return;
    scrollToRef.current!.scrollIntoView({
      behavior: "smooth"
    });

    // if diagnoses also selected, set Total OB checkbox to visible
    if (diagDataSource.length !== 0) {
      setOBCareVisible(true);
    }
  };

  const handleIpaAdviseSelect = () => {
    confirm({
      title: 'IPA ADVISE',
      icon: <ExclamationCircleOutlined />,
      content: 'By selecting IPA Advise, you are agreeing for our UM department to select the provider.',
      onOk: setIpaAdviseAsProvider,
      onCancel() {},
    });
  };

  const setIpaAdviseAsProvider = () => {
    return props.getIpaAdvise(props.authMember.RmiCompanyId)
      .then((response: any) => {
        setProvider(response[0]);
        setLocation(response[0].RmiCity);

        if (scrollToRef === null) return;
        scrollToRef.current!.scrollIntoView({
          behavior: "smooth"
        });

        // if diagnoses also selected, set Total OB checkbox to visible
        if (diagDataSource.length !== 0) {
          setOBCareVisible(true);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  // Add base CPT used by manual and Ob total care to the CPTcode table
  const baseCptCode = (baseCode: string) => {
    let searchObject = {
      RmiSpecialtyProvKeyId: props.provider.RmiProviderKeyId,
      RmiReferToProvKeyId: provider.RmiProvKeyId,
      RmiCompanyId: props.authMember.RmiCompanyId,
      CPTCode: baseCode,
      ICDCode: additionalDiags.RmiDiagCode,
      RmiEndDate: props.authMember.RmiEndDate,
      RmiHpCode: props.authMember.RmiHpCode,
      RmiPhCode: "P",
      RmiStartDate: props.authMember.RmiStartDate,
      RmiSex: props.authMember.RmiSex,
      SpecCode: provider.RmiSpecCode,
      InitialVisit: inOutPatient,
      RmiMembKeyId: props.authMember.RmiMembKeyId,
      IsRheumatologyPainManagement: RHUPMFlag,
    };

    props.enquireService(searchObject)
      .then((response: any[]) => {
        let data = {
          cptCode: response[0].RmiProcCode,
          description: response[0].RmiDescr,
          modifier: null,
          diagRef: additionalDiags.RmiDiagCode,
          units: "1",
          ...response[0],
        };
        setCptDataSource(prev => [...prev, data]);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  }

  // Additional CPT Package Addition Control
  const addOBPackage = (baseCode: string, codes: any[]) => {
    const isDuplicateCPT = cptDataSource.some(data => data.cptCode === baseCode);

    if (isDuplicateCPT) {
      notifier.error('Duplicate CPT Code exists. Please select a different CPT.');
      setTotalOBCare(false);
      return;
    }

    //On OB care tab to add the baseCPT to the cptcode table
    if (POSTab === '2' && !isDuplicateCPT && !cptCode.RmiProcCode) {
      baseCptCode(baseCode);
    }

    if (!isDuplicateCPT) {
      codes.map(code => {
        let data = {
          cptCode: code.RmiSvcCode,
          description: code.RmiSvcDesc,
          modifier: null,
          diagRef: additionalDiags.RmiDiagCode,
          units: code.RmiQty,
          ...code
        };

        const isDuplicateCPT = cptDataSource.some(x => x.cptCode ===  data.cptCode);
        if (isDuplicateCPT) {
          notifier.error('Duplicate CPT Code exists.');
          return;
        } else {
          setCptDataSource(prev => [...prev, data]);
        }
      });

      // clear entries
      setCptCode({});
      setModifier({});
      form.resetFields(['cptCode', 'units', 'additionalModifiers']);
      getFacilities('21'); // TODO: This might be a bug on QA1

      Modal.warning({
        title: 'Clinical Info Needed',
        content: 'Clinical information is required in order to make determination. Please attach information to this authorization or enter a note that is 10 char or longer.',
      });
    }
  };

  const isTotalOBCare = (e: CheckboxChangeEvent) => {
    const checked = e.target.checked;

    if (checked) {

      setOBCodesModalVisible(true);

    } else {
      // unset stuff
      setCPSPVisible(false);
      setFacility({});
      setFacilityList([]);
    }

    setTotalOBCare(checked);
  };

  const handleOBCodeModalSubmit = () => {
    setOBCodesModalVisible(false);
    setCPSPVisible(true);
    confirm({
      title: 'Add total OB package service codes?',
      icon: <ExclamationCircleOutlined />,
      content: 'Auto-populated codes will be added. Continue?',
      onCancel() {
        const isDuplicateCPT = cptDataSource.some(data => data.cptCode === OBCodeSelection);
        if (isDuplicateCPT) {
          notifier.error('Duplicate CPT Code exists. Please select a different CPT.');
          setTotalOBCare(false);
        }

        //shortcut way to add OB care cptcodes
        if (POSTab === '2' && !isDuplicateCPT && !cptCode.RmiProcCode) {
          baseCptCode(OBCodeSelection);
          Modal.warning({
            title: 'Clinical Info Needed',
            content: 'Clinical information is required in order to make determination. Please attach information to this authorization or enter a note that is 10 char or longer.',
          });
        }

        //manual way to add OB care cptcodes
        if (!isDuplicateCPT && cptCode.RmiProcCode) {
          Modal.warning({
            title: 'Clinical Info Needed',
            content: 'Clinical information is required in order to make determination. Please attach information to this authorization or enter a note that is 10 char or longer.',
          });
        }

        setTotalOBCare(false);
        getFacilities('21'); // legacy cancel uses POS 21

        // clear entries
        setCptCode({});
        setModifier({});
        form.resetFields(['cptCode', 'units', 'additionalModifiers']);
      },
      onOk() {
        getOBCodes(cptCode.RmiProcCode ? cptCode.RmiProcCode : OBCodeSelection);
        setTotalOBCare(true);
      },
      okText: 'Yes, add the codes',
      width: '500px',
    });
  };

  const addDermatologyPackage = (units: number) => {
    confirm({
      title: "Add code 11102 and 99213 for Dermatology?",
      content: "The referred Provider is a Dermatology Specialist, would you like to add the codes for an Dermatology?",
      type: "warning",
      maskClosable: false,
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        setCptDataSource(prev => {
          return [...prev, {
            cptCode: "11102",
            RmiAdmitDate: cptCode.RmiAdmitDate,
            RmiDschDate: cptCode.RmiDschDate,
            description: "TANGNTL BX SKIN SINGLE LES",
            modifier: modifier.RmiModif,
            diagRef: additionalDiags.RmiDiagCode,
            units: units,
            RmiPhCode: cptCode.RmiPhCode
          }, {
            cptCode: "99213",
            RmiAdmitDate: cptCode.RmiAdmitDate,
            RmiDschDate: cptCode.RmiDschDate,
            description: "OFFICE/OUTPATIENT VISIT",
            modifier: modifier.RmiModif,
            diagRef: additionalDiags.RmiDiagCode,
            units: units,
            RmiPhCode: cptCode.RmiPhCode
          }]
        })
      },
      onCancel: () => {}
    });
  };

  const addUrinologyPackage = (units: number) => {
    confirm({
      title: "Add code 81000 for Urinalysis?",
      content: "The referred Provider is a Urology Specialist, would you like to add the code for an Urinalysis?",
      type: "warning",
      maskClosable: false,
      okText: "Yes, add the code",
      onOk: () => {
        setCptDataSource(prev => {
          return [...prev, {
            cptCode: "81000",
            description: "URINALYSIS NONAUTO W/SCOPE",
            modifier: modifier.RmiModif,
            diagRef: additionalDiags.RmiDiagCode,
            units: units,
            RmiPhCode: cptCode.RmiPhCode
          }]
        });
      },
      onCancel: () => {}
    });
  };

  const addEKGPackage = (units: number) => {
    confirm({
      title: "Add code 93000 for EKG?",
      content: "The referred Provider is a Cardiac Specialist, would you like to add the code for an EKG?",
      type: "warning",
      maskClosable: false,
      okText: "Yes, add the code",
      onOk: () => {
        setCptDataSource(prev => {
          return [...prev, {
            cptCode: "93000",
            description: "ELECTROCARDIOGRAM COMPLETE",
            modifier: modifier.RmiModif,
            diagRef: additionalDiags.RmiDiagCode,
            units: units,
            RmiPhCode: cptCode.RmiPhCode
          }]
        });
      },
      onCancel: () => {}
    });
  };

  const isInitialRequest = (e: CheckboxChangeEvent) => {
    const checked = e.target.checked;
    if (checked) {
      confirm({
        title: 'Initial Requests',
        icon: <ExclamationCircleOutlined />,
        content: 'For initial requests, you can request the IPA to select the appropriate provider.',
        onCancel: setIpaAdviseAsProvider,
        cancelText: 'Change to IPA Advise',
        onOk() {},
        okText: 'Keep Selected Provider',
        width: '500px',
      });
    }

    setInitialRequest(checked);
  };

  const onTabChange = (key: string) => {
    const OFFICE = fullPosList.find(x => x.RmiCode === '11');
    const INPATIENT = fullPosList.find(x => x.RmiCode === '21');
    const OUTPATIENT = fullPosList.find(x => x.RmiCode === '22');

    //reset selected facility when switch tab
    setFacility({});

    if (key === '1') {
      form.setFieldsValue({ pos: OFFICE.Code });
      setPos(OFFICE);
    };

    if (key === '2') { // Total OB care
      form.setFieldsValue({ pos: OFFICE.Code });
      setPos(OFFICE);
      setPosList([OFFICE, INPATIENT, OUTPATIENT]);
    } else {
      setPosList(fullPosList);
    }

    // unset radio choices
    setPosType('');

    key === POSTab ? setPOSTab('none') : setPOSTab(key);
  };

  const handlePosSelect = (value: any) => {
    const posCode = JSON.parse(value).RmiCode;
    if (['12', '19', '21', '22', '24'].includes(posCode)) {
      Modal.warning({
        title: 'Clinical Info Needed',
        content: 'Clinical information is required in order to make determination. Please attach information to this authorization.',
      });
    }

    if (['19', '21', '22', '24'].includes(posCode)) {
      getFacilities(posCode);
    }

    setPos(JSON.parse(value));
    //reset selected facility when switching to a different POS
    setFacility({});
  };

  const tabSelectEvent = (evt: any, searchResult: any[], id: string) => {
    if (searchResult.length > 0 && evt.key === 'Tab') {
      const enterKey = new KeyboardEvent('keydown', {
        code: 'Enter',
        key: 'Enter',
        charCode: 13,
        keyCode: 13,
        view: window,
        bubbles: true
      });

      document.getElementById(id)!.dispatchEvent(enterKey);
    }
  }

  const onPOSRadioChange = (e: any) => {

    const radioValue = e.target.value;
    switch(radioValue) {
      case 'Pharmacy':
        setPosList(fullPosList.filter(x => ['11', '12'].includes(x.RmiCode)));
        break;
      case 'Dialysis':
        const DIALYSIS = fullPosList.filter(x => ['65'].includes(x.RmiCode));
        setPosList(DIALYSIS);
        setPos(DIALYSIS[0]);
        form.setFieldsValue({ pos: DIALYSIS[0].Code });
        break;
      case 'Lab':
        const LAB = fullPosList.filter(x => ['81'].includes(x.RmiCode));
        setPosList(LAB);
        setPos(LAB[0]);
        form.setFieldsValue({ pos: LAB[0].Code });
    }

    setPosType(radioValue);
  };

  const onPOSRadioChange2 = (e: any) => {
    const radioValue = e.target.value;
    switch(radioValue) {
      case 'Surgery Center':
        const SURGERY_CENTER = fullPosList.find(x => ['24'].includes(x.RmiCode));
        form.setFieldsValue({ pos: SURGERY_CENTER ? SURGERY_CENTER.Code : {} });
        setPos(SURGERY_CENTER ? SURGERY_CENTER : {});
        getFacilities('24');
        break;
      case 'Outpatient Hospital Setting':
        const OUTPATIENT = fullPosList.find(x => ['22'].includes(x.RmiCode));
        form.setFieldsValue({ pos: OUTPATIENT ? OUTPATIENT.Code : {} });
        setPos(OUTPATIENT ? OUTPATIENT : {});
        getFacilities('22');
        break;
      case 'Inpatient Procedure':
        const IMPATIENT_PROCEDURE = fullPosList.find(x => ['21'].includes(x.RmiCode));
        form.setFieldsValue({ pos: IMPATIENT_PROCEDURE ? IMPATIENT_PROCEDURE.Code : {} });
        setPos(IMPATIENT_PROCEDURE ? IMPATIENT_PROCEDURE : {});
        getFacilities('21');
        break;
      case 'Tertiary Care':
        const OFF_CAMPUS_HOSPITAL = fullPosList.find(x => ['19'].includes(x.RmiCode));
        form.setFieldsValue({ pos: OFF_CAMPUS_HOSPITAL ? OFF_CAMPUS_HOSPITAL.Code : {} });
        setPos(OFF_CAMPUS_HOSPITAL ? OFF_CAMPUS_HOSPITAL : {});
        getFacilities('19');
        break;
    }

    setFacility({});
    setPosType(radioValue);
  };

  const calculateAge = () : number => {
    let dateFromString = new Date(tempAuthNumber.DateCreated);
    let birthdate = new Date(props.authMember.RmiBirth);

    let diff = (dateFromString.getTime() - birthdate.getTime()) / 1000;

    return Math.floor(diff / 31556926);
  };

  // Upload Files
  const handleUpload = (authConfirmed: any) => {

    const createFileData = new Promise((resolve, reject) => {
      let authPcpName = null;
      let authFirstName = null;

      if (referringPhysician.RmiRevFullName !== null) {
          const pcpName = referringPhysician.RmiRevFullName.split(',');
          authPcpName = pcpName[0];
          const firstName = pcpName[1] ? pcpName[1].split('(') : pcpName;
          authFirstName = firstName[0];
      } else {
          authPcpName = null;
          authFirstName = null;
      }
      if (!provider) {
        reject('Please select a Provider before uploading files.')
      }
      const reqProvName = provider ? provider.RmiRevFullName.split(',') : '';
      const birth = props.authMember.RmiBirth.split('T');

      resolve({
        'companyId': referringPhysician.RmiCompanyId,
        'authNo': tempAuthNumber.TempAuthNumber,
        'memberId': props.authMember.RmiMembId,
        'membLast': props.authMember.RmiLastNm,
        'membFirst': props.authMember.RmiFirstNm,
        'dob': birth[0],
        'authPcpId': referringPhysician.RmiProvKeyId,
        'authPcpLast': authPcpName,
        'authPcpFirst': authFirstName,
        'reqProvId': provider.RmiProvId,
        'reqProvLast': reqProvName[0],
        'reqProvFirst': reqProvName[1],
        'date': moment().toString(),
      });
    });

    const fileData = new FormData();
      attachmentList.forEach((file: any) => {
        fileData.append('authFile[]', file);
      });

      createFileData.then((data: any) => {
        fileData.append("companyId", authConfirmed.companyId);
        fileData.append("authNo", authConfirmed.authNumber);
        fileData.append("memberId", data.memberId);
        fileData.append("membLast", data.membLast);
        fileData.append("membFirst", data.membFirst);
        fileData.append("dob", data.dob);
        fileData.append("authPcpId", data.authPcpId);
        fileData.append("authPcpLast", data.authPcpLast);
        fileData.append("authPcpFirst", data.authPcpFirst);
        fileData.append("reqProvId", data.reqProvId);
        fileData.append("reqProvLast", data.reqProvLast);
        fileData.append("reqProvFirst", data.reqProvFirst);
        fileData.append("date", data.date);

        return props.uploadFilestoAuth(fileData)
          .then(() => {
            // send authorization number to confirm page.
            props.triggerConfirmAuthPage(authConfirmed);
          })
          .catch((err: ErrorResponse) => {
            notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
          });
    })
    .catch((err: string) => {
      notifier.error(err);
    });
  };

  const confirmPainClinicAuthSubmission = (values: any) => {
    var phoneNumber = "";
    switch (referringPhysician.RmiCompanyId) {
      case "APC":
        phoneNumber = "626 282 0288 x5909";
        break;
      case "AHC":
        phoneNumber = "626 282 0288 x5975";
        break;
      case "ALPHA":
        phoneNumber = "844 426 2264";
    }
    confirm({
      title: 'Musculoskeletal and Pain Clinic Authorization!',
      icon: <ExclamationCircleOutlined />,
      content: `OK to submit to Musculoskeletal and Pain Clinic. Requested Provider will be modified to Integrative Sports & Spine. If any questions, please call
        ${phoneNumber}`,
      onOk: () => onSubmit(values),
      onCancel() {
        setIsSubmitting(false);
      },
    });
  }

  const confirmChestClinicAuthSubmission = (values: any) => {
    confirm({
      title: 'Lung Nodule and Chest Clinic Authorization!',
      icon: <ExclamationCircleOutlined />,
      content: `OK to submit to Lung Nodule and Chest Clinic. Requested Provider will be modified to Jairo Espinosa. If any questions, please call
        ${referringPhysician.RmiCompanyId == "APC" ? "626 282 0288 x5909" : "626 282 0288 x5975"}`,
      onOk: () => onSubmit(values),
      onCancel() {
        setIsSubmitting(false);
      },
    });
  }

  const confirmAuthSubmission = (values: any) => {
    confirm({
      title: 'Are you sure?',
      icon: <ExclamationCircleOutlined />,
      content: 'You will NOT be able to make changes to this Authorization Request once it\'s submitted.',
      onOk: () => onSubmit(values),
      onCancel() {
        setIsSubmitting(false);
      },
    });
  }

  const onSubmitValidation = async () => {
    setIsSubmitting(true);
    form.validateFields().then(async values => {
      let duplicateAuthCheck = await duplicateAuthValidation();
      if (!duplicateAuthCheck) onSubmitAlert();
    })
    .catch(err => {
      if (err) {
        notifier.error('Please complete all required fields.');
        form.scrollToField(err['errorFields'][0]['name'][0], { behavior: 'smooth' })
        setIsSubmitting(false)
      }
    });
  }

  const onSubmitAlert = async () => {

    setIsSubmitting(true);
    form.validateFields().then(async values => {

      // Check for required attachments
      if (['12', '19', '21', '22', '24'].includes(pos.RmiCode) && attachmentList.length === 0 && values.symptomTreatment.length < 10) {
        notifier.error("Clinical information is required in order to make determination. Please attach information to this authorization or enter a note that is 10 char or longer.");
        return;
      }

      // Urgent requests require an attachment
      if (referralType.RmiReferralType == "UR" && attachmentList.length === 0 && attachmentRequired) {
        notifier.error("Urgent auths require an attachment.");
        return;
      }

      const CPTCodes = cptDataSource.map(value => value.cptCode);

      if (menstrualDate && (moment(menstrualDate).isBefore(moment().subtract(120, 'days')))) {
        confirm({
          title: 'Reminder',
          icon: <ExclamationCircleOutlined />,
          content: 'Are you sure the "last menstrual period date" is correct? It should not be older than 120 days.',
          onOk: () => confirmAuthSubmission(values),
          onCancel() { },
        });
      } else {
        const primaryICD = diagDataSource[0]?.RmiDiagCode || "";


        const painManagementPayload = {
          PcpLocation: referringPhysician.RmiLocation ? referringPhysician.RmiLocation.Geography.WellKnownText : null,
          ProvId: provider.RmiProvId,
          RefProvKeyId: referringPhysician.RmiProvKeyId,
          CompanyId: props.authMember.RmiCompanyId,
          SpecCode: provider.RmiSpecCode,
          MemberKeyId: props.authMember.RmiMembKeyId,
          ICDCodes: [primaryICD],
          referralType: referralType.RmiReferralType,
          CPTCodes,
          POS: pos.RmiCode
        };

        let isPainClinic = false;
        let isChestClinic = false;

        props.validatePulmNoduleAndPainClinic(painManagementPayload)
          .then((pmResponse: any) => {
            isPainClinic = pmResponse?.PainClinic || isPainClinic;
            isChestClinic = pmResponse?.ChestClinic || isChestClinic;

            if (isChestClinic) {
              confirmChestClinicAuthSubmission(values);
            } else if (isPainClinic) {
              confirmPainClinicAuthSubmission(values);
            } else {
              confirmAuthSubmission(values);
            }
          })
        }
      })
      .catch(err => {
        if (err) {
          notifier.error('Please complete all required fields.');
          form.scrollToField(err['errorFields'][0]['name'][0], { behavior: 'smooth' })
          setIsSubmitting(false)
        }
      });
  };

  const onSubmit = async (values: any) => {
    let age = calculateAge();


    // According to Melissa, acknowledgement logic can be removed
    // if (providerAcknowledgement.length > 0) {
    //   props.acknowledgement(providerAcknowledgement, props.authMember.RmiMembKeyId, props.authMember.RmiCompanyId);
    // }

    let authDiagModels: any = diagDataSource.map((value: any, index: number) => {
      return {
        RmiAuthNo: tempAuthNumber.TempAuthNumber,
        RmiDiag: value.RmiDiagCode,
        RmiDiagDesc: value.RmiDiagDesc,
        RmiCompanyId: referringPhysician.RmiCompanyId,
        RmiDiagFromDate: value.RmiEffectDate,
        RmiDiagRefNo: index >= 3 ? index+=2 : ++index, //if index>=3, we need to skip over 1 index for the Referral Type entry (e.g Routine Referral) so that all entries can be entered into DB correctly.
      };
    });

    authDiagModels.push({
      RmiAuthNo: tempAuthNumber.TempAuthNumber,
      RmiDiag: referralType.RmiReferralType,
      RmiDiagDesc: referralType.RmiReferralDesc,
      RmiCompanyId: referringPhysician.RmiCompanyId,
      RmiDiagRefNo: 4,
    });

    //group modifier auth in the cpt code table
    let authDetailModels = [];
    for (const value of cptDataSource) {
      if (value.modifier?.length > 0) {
        for (const modif of value.modifier) {
          authDetailModels.push({
            RmiAuthNo: tempAuthNumber.TempAuthNumber,
            RmiProcCode: value.cptCode,
            RmiDescr: value.description,
            RmiModif: modif,
            RmiDiagRefNum: value.diagRef,
            RmiQty: value.units,
            RmiCompanyId: referringPhysician.RmiCompanyId,
            RmiAdmitDate: value.RmiAdmitDate ? value.RmiAdmitDate : undefined,
            RmiDschDate: value.RmiDschDate ? value.RmiDschDate : undefined,
            RmiPhCode: value.RmiPhCode
          });
        };

      } else {
        authDetailModels.push({
          RmiAuthNo: tempAuthNumber.TempAuthNumber,
          RmiProcCode: value.cptCode,
          RmiDescr: value.description,
          RmiModif: value.modifier,
          RmiDiagRefNum: value.diagRef,
          RmiQty: value.units,
          RmiCompanyId: referringPhysician.RmiCompanyId,
          RmiAdmitDate: value.RmiAdmitDate ? value.RmiAdmitDate : undefined,
          RmiDschDate: value.RmiDschDate ? value.RmiDschDate: undefined,
          RmiPhCode: value.RmiPhCode,
        });
      }
    }

    let authNoteModels = [
      {
        "RmiAuthNo": tempAuthNumber.TempAuthNumber,
        "RmiSubject": "Symptoms and Treatments",
        "RmiNotes": `${values.symptomTreatment}\r\n${sessionStorage.getItem('user_id')}\r\n`,
        "RmiCompanyId": referringPhysician.RmiCompanyId,
      },
      {
        "RmiAuthNo": tempAuthNumber.TempAuthNumber,
        "RmiSubject": "LETTER ADDRESS",
        "RmiNotes": props.provider.RmiSequence,
        "RmiCompanyId": referringPhysician.RmiCompanyId,
      }
    ];

    if (Object.values(facility).length > 0 && facility.LastName === 'OTHER HOSPITAL') {
      authNoteModels.push({
        RmiAuthNo: tempAuthNumber.TempAuthNumber,
        RmiSubject: "OTHER HOSPITAL NAME",
        RmiNotes: values.otherFac,
        RmiCompanyId: referringPhysician.RmiCompanyId
      })
    }

    if (mediCalCheck && benefitRestricted && restrictedCPTList.length > 0) {
      authNoteModels.push({
        RmiAuthNo: tempAuthNumber.TempAuthNumber,
        RmiSubject: restrictedCPTList.join(', ') + "Non-benefit",
        RmiNotes: "Item is not a covered benefit per Medi-cal TAR and non-benefit list",
        RmiCompanyId: referringPhysician.RmiCompanyId
      });
    }

    // Either uses the referral by from modify auth or primary care provider based on "props.modifyAuthReferralBy"
    let formData = {
      "AuthMasterModel": {
        "RmiAuthNo": tempAuthNumber.TempAuthNumber,
        "RmiReqProvKeyId": provider.RmiProvKeyId,
        "RmiReqProvLast": provider.RmiRevFullName,
        "RmiAuthPcpKeyId": referringPhysician.RmiProvKeyId ? referringPhysician.RmiProvKeyId : props.provider.PKey,
        "RmiReferBySequence":  props.modifyAuthReferralBy ? props.modifyAuthReferralBy.RmiSequence : props.provider.RmiSequence,
        "RmiReferByAddressId": props.modifyAuthReferralBy ? props.modifyAuthReferralBy.RmiAddressId : props.provider.RmiAddressId,
        "RmiSecondOpinion": secondOpinion,
        "RmiGlaucoma": glaucoma,
        "RmiMultiSpecialty": null,
        "RmiMembKeyId": props.authMember.RmiMembKeyId,
        "RmiSequence": props.provider.RmiSequence,
        "RmiReferToAddressId": provider.RmiAddressId,
        "RmiCompanyId": props.authMember.RmiCompanyId,
        "RmiHpCode": props.authMember.RmiHpCode,
        "RmiReqSpec": specialty.SpecCode,
        "RmiPlaceSvc": pos.RmiCode,
        "RmiExprDate": (menstrualDate && cptDataSource.find(e => OBG_CPTCODES.includes(e.cptCode)) && specialty.SpecCode === 'OBG') ? moment(menstrualDate).add(11, 'months').format('MM/DD/YYYY') : moment().add(expiryDays, 'days').format('MM/DD/YYYY'),
        "RmiAuthDate": retroDos !== '' ? retroDos : moment().format(),
        "RmiRetroDate": retroDos !== '' ? (referralType?.RmiReferralType === 'RA' ? retroDos : null) : null,
        "RmiSvcType": pos.RmiCode === '21' && retroDos === '' ? 'EL' : null,
        "RmiSvcFacIdKeyId": facility.ProvKeyId,
        "RmiFacilityAddressId": facility.AddressId,
        "RmiMemberStartDate": moment(props.authMember.RmiStartDate).format('MM-DD-YYYY'),
        "RmiAge": age,
        "RmiGender": props.authMember.RmiSex,
        "RmiUserId": sessionStorage.getItem('user_id'),
        "RmiPriorityStatus": "0", // Has been zero since 2016, what is this for?
        "RmiCreatedBy": "888",
        "RmiModifiedBy": "888",
        "RmiReferralType": referralType.RmiReferralType,
        "RmiEstDob": dueDate,
        "RmiLmpDt": menstrualDate,
        "RmiOtherFacility": values.otherFac,
        "RmiContact": values.contactInformation,
        "NoAutoApprove": noAutoApprove,
      },
      "AuthDiagModels": authDiagModels,
      "AuthDetailModels": authDetailModels,
      "AuthNoteModels": authNoteModels,
    };

    let authValidation = await priorAuthValidation();

    if (authValidation) {
      props.submitConfirmedAuth(formData)
        .then((response: any) => {
          if (response.RmiBlockAuth === 'Y') {
            setIsSubmitting(false);

            Modal.error({
              title: ModalTitles.AUTH_REQUEST_BLOCKED,
              content: <div dangerouslySetInnerHTML={{ __html: response.RmiMessage}} />,
              maskClosable: false,
            });
          } else {
            if (mediCalCheck && CPSP && CPSP !== null) {
              let CPSPmodel = {
                CompanyId: response.companyId,
                MembMpiNo: props.authMember.RmiMembMpiNo,
                AuthPcpKeyId: formData.AuthMasterModel.RmiAuthPcpKeyId,
                AuthDate: formData.AuthMasterModel.RmiAuthDate,
                Status: CPSP,
                AuthNo: response.authNumber
              };
              props.postCPSP(CPSPmodel)
              .catch((err: ErrorResponse) => {
                notifier.error(err.response.data.Message || 'Unable to save CPSP information, please contact a system administrator.');
              });
            }

            // if modify auth, then expire the previous auth to today's date
            if (props.previousAuthNumber) {
              props.expireAuth(props.previousAuthNumber, props.authMember.RmiCompanyId).catch((err: ErrorResponse) => {
                notifier.error(err.response.data.Message || `Something went wrong cancelling previous auth. ${props.previousAuthNumber}`);
              });
            }

            if (attachmentList.length > 0) {
              // Upload files
              handleUpload(response);
            } else {
              // send authorization number to confirm page.
              props.triggerConfirmAuthPage(response);
            }
          }
      })
      .catch((err: ErrorResponse) => {
        setIsSubmitting(false);
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
    }
  };

  const preSelectNotifications = () => {
    //pre-populate notifications
    props.authDetailState.letterInfos && Promise.all(props.authDetailState.letterInfos.map(async (data: letterInfosData) => {
      if (data.fileName?.indexOf('PROVIDER_APPROVAL') !== -1) {
        var filePath = data.fileLocation === "AYCE" ? `${data.fileLocation}\\${data.fileName}` : `${data.fileLocation}${data.fileName}`;
        setOriginalFileNames((names) => [...names, data?.fileName]);
        props.downloadResources(filePath)
          .then((response: any) => {
            let ext = getBlobTypeFromFileExtension(data.fileName.split('.').pop()?.toLowerCase());
            let file = new File([response], data.fileName, { type: "application/" + ext });
            setAttachmentList((prevFiles) => [...prevFiles, file]);
          })
          .catch((err: ErrorResponse) => {
            notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
          });
      }
    }));
  };

  const preSelectAttachments = () => {
    //pre-populate the attachment list on page render, as we want all options pre-selectd by default.
    props.authDetailState.attachments && Promise.all(props.authDetailState.attachments.map(async (data: attachmentData) => {
      const downloadAttachmentParams = {
        AuthNo: data?.authNo,
        CompanyId: data?.companyId,
        FileLocation: data?.folderLocation,
        FileName: data?.fileName,
        IsModificationAuth: true
      };
      setOriginalFileNames((names) => [...names, data?.fileMeta]);
      props.downloadAttachment(downloadAttachmentParams)
          .then((response: any) => {
            let ext = getBlobTypeFromFileExtension(data.fileName.split('.').pop()?.toLowerCase());
            let file = new File([response], data.fileMeta || data.fileName, {type: "application/" + ext});
            setAttachmentList((prevFiles) => [...prevFiles, file]);
        })
        .catch((err: ErrorResponse) => {
          notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
    }));
  };

  const changeFacility = (facility: any) => {
    setFacility(facility);
    if ((pos.RmiCode === '21' || pos.RmiCode === '22') && MAMMOGRAM_EXCLUDED_PROVIDER_KEY_LIST.includes(facility.ProvKeyId.toUpperCase())) {
      setCptDataSource([]);
      form.resetFields(['cptCode', 'units', 'modifier', 'additionalModifiers']);
    }
  };

  const okForAuthSubmission = () => {
    const request = {
      ProvKeyId: props.provider.RmiProvKeyId,
      ProvId: props.provider.RmiProvId,
      CompanyId: props.authMember.RmiCompanyId,
      PosCode: (pos && pos.RmiCode ? pos.RmiCode: ''),
      SpecCode: (specialty && specialty.SpecCode ? specialty.SpecCode : '')
    };
    props.checkProviderForAuthSubmission(request)
      .then((response: boolean) => {
        if (!response) {
          showAuthSubmissionBlockingModalForAutoPaidClaims();
          setIsSubmitting(false);
          setIsClaimsAutoPaidForProvider(true);
        } else {
          setIsClaimsAutoPaidForProvider(false);
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    });
  };

  const getDistanceInMiles = (distance: number) => { 
    if (distance == null && !selfReferral ) return "Distance not available"; 
    
    let distanceInMiles = `${Math.round((distance + Number.EPSILON) * 100) / 100} miles away`;
    return distanceInMiles;
  };

  const checkIpaAdviseIsPresent = () => {
    return props
      .getIpaAdvise(props.authMember.RmiCompanyId)
      .then((response: any) => {
        if (response === null || response.length === 0) setIsIpaAdvisePresent(false);
        else setIsIpaAdvisePresent(true);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  return (
    <div className="row flex-lg-wrap justify-content-start mb-3 ml-0 mt-3">

      <SpecialtyQuestionnaireModal
        visible={specialtyQuestionnaireModalVisible}
        handleSubmit={handleSpecialtySubmit}
        selectedProvider={provider}
        reminderText={reminderText}
        title={specialtyQuestionnaireTitle}
        maskClosable={false}
        closeIcon={<></>}
      />

      <OBCodesModal
        visible={OBCodesModalVisible}
        setOBCodeSelection={setOBCodeSelection}
        OBCodeSelection={OBCodeSelection}
        title={'Please select a primary OB Code'}
        onCancel={() => {
          setTotalOBCare(false);
          setOBCodesModalVisible(false);
        }}
        onOk={handleOBCodeModalSubmit}
        okText={'Submit'}
      />

      <PainManagementModal
        visible={painManagementModalVisible}
        title={'Pain Management Questionnaire'}
        onCancel={() => {
          setPainManagementModalVisible(false);
        }}
        okText={'Submit'}
        companyId={getDisplayCompanyId(props.authMember.RmiCompanyId)}
        handleSubmit={handlePainManagementSubmit}
        isFetchingProviderList={props.isFetchingProviderList}
      />

      <JCodeQuestionnaireModal
        visible={jCodeQuestionnaireVisible}
        title={'J Code Questionnaire'}
        onCancel={() => {
          setJCodeQuestionnaireVisible(false);
        }}
        okText={'Submit'}
        handleSubmit={handleJCodeQuestionnaireSubmit}
      />

      <VendorProviderInputModal
        visible={vendorProviderInputModalVisible}
        okText={'Enter'}
        handleSubmit={handleVendorProviderInputSubmit}
      />

      <DuplicateAuthsModal
        getPortalAuth={props.getPortalAuth}
        getAttachInfo={props.getAttachInfo}
        duplicateAuthModalDataSource={duplicateAuthModalDataSource}
        isDuplicateAuthsModalVisible={isDuplicateAuthModalVisible}
        isDuplicateAuthsModalVisibleHandler={isDuplicateAuthModalVisibleHandler}
        onSubmitAlertCallHandler={onSubmitAlertCallHandler}
        isFetchingAuth={props.isFetchingAuth}
      />

      <div className={`${styles['member-search']} row flex-lg-wrap justify-content-start mb-4 ml-0`}>
        <Card title="Member Information" headStyle={{ background: '#1D84C6', color: 'white' }} style={{ width: '100%' }}>
          <div className={`row ${styles['member-info-heading']}`}>
            <div className="col-lg-7 col-md-4">
              <dl>
                <dt>Member Name</dt>
                <dd>{props.authMember.RmiLastNm}, {props.authMember.RmiFirstNm}</dd>
              </dl>
            </div>
            <div className="col-lg-2 col-md-4">
              <dl>
                <dt>Gender</dt>
                <dd>{props.authMember.RmiSex}</dd>
              </dl>
            </div>
            <div className="col-lg-3 col-md-4">
              <dl>
                <dt>DOB</dt>
                <dd>{props.authMember.RmiBirth ? moment(props.authMember.RmiBirth).format('MM/DD/YYYY') : ''}</dd>
              </dl>
            </div>
            <div className="col-lg-6 col-md-4">
              <dl>
                <dt>Health Plan</dt>
                <dd>{props.authMember.RmiHpName}</dd>
              </dl>
            </div>
            <div className="col-lg-6 col-md-4">
              <dl>
                <dt>Member ID</dt>
                <dd>{props.authMember.RmiMembId}</dd>
              </dl>
            </div>
          </div>
        </Card>
      </div>

      <div className={`${styles['member-search']} row flex-lg-wrap justify-content-start mb-4 ml-0`}>
        <Card
          title="Authorization Information"
          headStyle={{ background: '#1D84C6', color: 'white' }}
          style={{width: '100%'}}
        >
          <Form
            form={form}
            name={"authCreateForm"}
            onFinish={onSubmitValidation}
            initialValues={{
              units: '1',
            }}
            scrollToFirstError
          >
          <div className="row">
            <div className={retroDatePickerVisible ? 'col-lg-5' : 'col-lg-10'}>
              <FloatLabel
                label="Referral Type"
                value={referralType}
                star
              >
                <Select
                  value={referralType.RmiReferralDisp}
                  placeholder="Referral Type"
                  onSelect={onSelectReferralType}
                  loading={props.isFetchingReferTypes}
                >
                  {referTypeList.map((value: any) => (
                    <Option key={value.RmiUid} value={JSON.stringify(value)}>
                      {value.RmiReferralDisp}
                    </Option>
                  ))}
                </Select>
              </FloatLabel>
            </div>
            {retroDatePickerVisible ? (
              <div className="col-lg-5 col-md-5">
                <FloatLabel
                  label="Retro Date"
                  value={retroDos}
                >

                  <DatePickerLocalised
                    date={retroDos}
                    setDate={setRetroDos}
                    disabledDate={disabledDate}
                  />

                </FloatLabel>
              </div>
            ) : null }
            <div className="col-lg-10 col-md-4">
              <FloatLabel label="Referring Physician" value={referringPhysician}>
                <Input
                  value={referringPhysician.RmiRevFullName}
                  placeholder="Referring Physician"
                />
              </FloatLabel>
            </div>
            {(isPcp || showReferral) ? (
              <div className="col-lg-4 col-md-4 mt-2">
                <Checkbox
                  checked={selfReferral}
                  onChange={isSelfReferral}
                />&nbsp;&nbsp;Self-Referral
              </div>
            ) : null }
          </div>
            <div className="row mb-2">
              <div className="col-lg-8 col-md-8">
              <Title level={5}>
                Select Specialty: <span style={{color: 'red'}}>*</span>
              </Title>
                <div>
                  {specCodeList.map((spec: any) => {
                    if (spec.anchorLetter)
                      return <a className={styles['letters']} key={spec.anchorLetter} onClick={() => scrollToSpecialty(spec.anchorLetter)}>{spec.anchorLetter}</a>;
                  })}
                </div>

                <div
                  style={{
                    height: 400,
                    overflowY: 'auto',
                    padding: '0 16px',
                    border: '1px solid rgba(140, 140, 140, 0.35)',
                  }}
                  id="spec-list"
                >
                  <List
                    itemLayout="horizontal"
                    dataSource={specCodeList}
                    loading={props.isFetchingSpecCodes}
                    renderItem={spec => (
                      <List.Item>
                        <a
                          id={spec?.anchorTag}
                          key={spec.SpecCode}
                          ref={scrollToSpec}
                          href={spec?.anchorTag}
                          onClick={(event) => handleSpecCodeSelect(JSON.stringify(spec), event)}>
                          {spec.Description}
                        </a>
                      </List.Item>
                    )}
                  />
                </div>
              </div>

              <div className="col-lg-8 col-md-8">
                <div className="mb-2">
                  <div className="row">
                    <div className="col-lg-24 col-md-24 mb-1">
                      <FloatLabel
                        label="Select Provider"
                        name="provider"
                        form={form}
                        star
                        rules={[
                          () => ({
                            async validator(_: any, __: any) {
                              if (provider && Object.keys(provider).length !== 0) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error('Required'));
                            },
                          })
                        ]}
                      >
                        <Input
                          onChange={e => handleProviderSearch(e.target.value)}
                          disabled={providerList.length === 0}
                        />
                      </FloatLabel>
                    </div>
                  </div>

                  <div style={{
                    height: foundProviderList && foundProviderList.length > 0 ? 400 : undefined,
                    overflow: 'auto',
                    padding: '0 16px',
                    border: '1px solid rgba(140, 140, 140, 0.35)',
                  }}>
                    <List
                      itemLayout="horizontal"
                      dataSource={foundProviderList}
                      loading={props.isFetchingProviderList || props.isPostingPainMgmt || props.isFetchingCECProviders || props.isFetchingProviderByName}
                      renderItem={(item, index) => (
                        <List.Item key={index}>
                          <a onClick={() => handleProviderSelect(item)}>{item.RmiRevFullName}</a>&nbsp;&nbsp;({getDistanceInMiles(item.Distance)})
                          <br />
                          {item.RmiStreet}
                          <br />
                          {item.RmiCity}
                          <br />
                          {item.RmiPhone}
                          <br />
                          <Tooltip placement="topLeft" title={item.RmiLanguageDesc}>{item.RmiLanguage?.split(',').join(', ')}</Tooltip>
                        </List.Item>
                      )}
                    />
                  </div>
                  <Button
                    type="primary"
                    style={{ width: '100%'}}
                    onClick={() => handleIpaAdviseSelect()}
                    loading={props.isFetchingProviderList}
                    disabled={IPAAdviseDisable}
                  >
                    <InfoCircleOutlined />IPA HELP TO CHOOSE PROVIDER
                  </Button>
                </div>
              </div>

              <div className="col-lg-8 col-md-8">
                {cityList.length > 0 ? (
                  <>
                    <Title level={5}>
                      Select Location: <span style={{color: 'red'}}>*</span>
                    </Title>
                    <div>
                      {cityList.map((city: any) => {
                        if (city.anchorLetter)
                          return <a className={styles['letters']} key={city.anchorLetter} onClick={() => scrollToCityName(city.anchorLetter)}>{city.anchorLetter}</a>;
                      })}
                    </div>

                    <div
                      style={{
                        height: 400,
                        overflowY: 'auto',
                        padding: '0 16px',
                        border: '1px solid rgba(140, 140, 140, 0.35)',
                      }}
                    >
                      <List
                        itemLayout="horizontal"
                        dataSource={cityList}
                        loading={props.isFetchingCityList}
                        renderItem={city => (
                          <List.Item>
                            <a
                              id={city?.anchorTag}
                              key={city}
                              ref={scrollToCity}
                              href={city?.anchorTag}
                              onClick={(event) => handleCitySelect(city.name, event)}>
                              {city.name}
                            </a>
                          </List.Item>
                        )}
                      />
                    </div>
                  </>
                ) : null }
              </div>
            </div>

            <div className={`row ${styles['justify-space-between']}`}>
              <div className="col-lg-8 col-md-8 mb-2">
                <table className="test"  style={{ textAlign: "left", tableLayout: 'fixed', width: '100%' }}>
                  <tbody>
                    <tr>
                      <th>Refer To:</th>
                      <td>{provider ? (
                    <>
                    {provider.RmiRevFullName}
                    <br />
                    {provider.RmiStreet}
                    <br />
                    {provider.RmiCity}
                    <br />
                    {provider.RmiPhone}
                    </>
                  ) : 'No Provider Selected.'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-lg-12 col-md-12">
                <table className="test"  style={{ textAlign: "left" }}>
                  <tbody>
                    <tr>
                      <th>Selected Specialty:</th>
                      <td>{specialty && specialty.SpecCode ? (`${specialty.SpecCode} - ${specialty.Description}`) : 'No Specialty Selected.'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
            {(provider?.RmiOfficeHours || provider?.RmiAgeRestrictions || provider?.RmiHospitalAffiliations) && (
              <div className="col-lg-8 col-md-8 mb-4">
                <table className="test"  style={{ textAlign: "left", tableLayout: 'fixed', width: '100%' }}>
                  <tbody>
                    {provider.RmiOfficeHours && (
                      <tr>
                        <th>Office Hours:</th>
                        <td>{provider.RmiOfficeHours}</td>
                      </tr>
                    )}
                    {provider.RmiAgeRestrictions && (
                      <tr>
                        <th>Age Restrictions:</th>
                        <td>{provider.RmiAgeRestrictions}</td>
                      </tr>
                    )}
                    {provider.RmiHospitalAffiliations && (
                      <tr>
                        <th>Hospital Affiliations:</th>
                        <td>{provider.RmiHospitalAffiliations}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            </div>
            <div className="row" ref={scrollToRef}>
              <Title
                level={5}
                className="ml-3 mr-4"
              >
                Place of Service: <span style={{color: 'red'}}>*</span>
              </Title>
            </div>

            <Tabs
              activeKey={POSTab}
              onChange={onTabChange}
            >
              <TabPane tab="Office Visit/Office Procedure/Radiology" key="1">
                <Radio.Group
                  onChange={handleInOutPatient}
                  value={inOutPatient}
                >
                  <Radio value={"initial"}>Initial Visit</Radio>
                  <Radio value={"followUp"}>Follow up</Radio>
                </Radio.Group>
              </TabPane>
              {props.authMember?.RmiSex !== 'M' && (
                <TabPane tab="Total OB Care" key="2" className="justify-content-between">

                  {attachmentList.length === 0 ? (
                   <Alert className="col-lg-10 col-md-4 mb-1" message="Please attach or document medical records" type="warning" showIcon />
                  ) : null}

                  {OBCareVisible && mediCalCheck ? (
                    <>
                    {totalOBCare && (<Alert
                      className="col-lg-10 col-md-4 mb-2"
                      message="Facility is required" type="warning" showIcon
                    />)}
                    <Checkbox
                      checked={totalOBCare}
                      onChange={isTotalOBCare}
                    />&nbsp;&nbsp;Include Total OB Care Package?
                    </>
                  ) : (
                    mediCalCheck && (<Alert className="col-lg-10 col-md-4" message="Enter CPT Code and select a provider to see total OB checkbox" type="info" showIcon />)
                  )}
                  <div className="row">
                    <div className="col-lg-8">
                      <FloatLabel
                        label="Enter Last Menstrual Period Date"
                        name={'menstrualDate'}
                        value={menstrualDate}
                        form={form}
                        rules={[
                          () => ({
                            async validator(_: any, __: any) {
                              if (POSTab !== '2') return Promise.resolve();
                              else {
                                if (!menstrualDate) return Promise.reject(new Error('Required'));
                                if (!moment(menstrualDate).isValid()) return Promise.reject(new Error('Must be in a correct date format'))
                                if (moment(menstrualDate).isAfter(moment().endOf('day'))) return Promise.reject(new Error('Cannot be a future date.'));
                                return Promise.resolve();
                              }
                            },
                          })
                        ]}
                        star
                      >
                        <DatePickerLocalised
                          date={menstrualDate}
                          setDate={(date: any) => { setMenstrualDate(date); setDueDate(moment(date).add('9', 'months').format('MM/DD/YYYY')); }}
                          disabledDate={current => current > moment().endOf('day')}
                        />
                      </FloatLabel>
                    </div>
                    <div className="col-lg-8">
                      <FloatLabel
                        label="Enter Estimated Due Date"
                        value={dueDate}
                        name={'dueDate'}
                        form={form}
                        rules={[
                          () => ({
                            async validator(_: any, __: any) {
                              if (dueDate && !moment(dueDate).isValid()) return Promise.reject(new Error('Must be in a correct date format'))
                              return Promise.resolve();
                            },
                          })
                        ]}
                      >
                        <DatePickerLocalised
                          date={dueDate}
                          setDate={setDueDate}
                        />
                      </FloatLabel>
                    </div>
                  </div>
                </TabPane>
              )}
              <TabPane tab="Pharmacy/DME/Dialysis" key="3">

                {attachmentList.length === 0 && ['12', '19', '21', '22', '24'].includes(pos.RmiCode) ? (
                  <Alert className="col-lg-10 col-md-4 mb-2" message="Please attach or document medical records" type="warning" showIcon />
                ) : null }

                <Checkbox
                  checked={initialRequest}
                  onChange={isInitialRequest}
                />&nbsp;&nbsp;Is this an initial request?
                <br />

                <Radio.Group onChange={onPOSRadioChange} value={posType}>
                  <Radio value={"Pharmacy"}>Pharmacy</Radio>
                  <Radio value={"DME"}>DME</Radio>
                  <Radio value={"Dialysis"}>Dialysis</Radio>
                  <Radio value={"Lab"}>Lab</Radio>
                </Radio.Group>

              </TabPane>
              <TabPane tab="Inpatient or Outpatient Procedure or Tertiary Care" key="4">

                {attachmentList.length === 0 && ['12', '19', '21', '22', '24'].includes(pos.RmiCode) ? (
                  <Alert className="col-lg-10 col-md-4 mb-2" message="Please attach or document medical records" type="warning" showIcon />
                ) : null }
                {(Object.values(facility).length === 0 && (pos.RmiCode === '11' && cptDataSource.find(e => OBG_CPTCODES.includes(e.cptCode))) ||
                  (Object.values(facility).length === 0 && ['21', '22', '24'].includes(pos.RmiCode))) ? (
                  <Alert className="col-lg-10 col-md-4 mb-2" message="Facility is required" type="warning" showIcon />
                ) : null }

                <Radio.Group onChange={onPOSRadioChange2} value={posType}>
                  <Radio value={"Surgery Center"}>Surgery Center</Radio>
                  <Radio value={"Outpatient Hospital Setting"}>Outpatient Hospital Setting</Radio>
                  <Radio value={"Inpatient Procedure"}>Inpatient Procedure</Radio>
                  <Radio value={"Tertiary Care"}>Tertiary Care</Radio>
                </Radio.Group>

              </TabPane>
            </Tabs>

            <FloatLabel
              className="mb-2"
              label="Place of Service"
              name="pos"
              form={form}
              value={pos}
              required
            >
              <Select
                id="pos"
                showSearch
                value={pos.Code}
                onSelect={handlePosSelect}
                loading={props.isFetchingPOS}
                placeholder={'Search for Place of Service...'}
                disabled={posList.length === 0}
                optionFilterProp="children"
                defaultActiveFirstOption={true}
                filterOption={(input, option: any) =>
                  option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                filterSort={(optionA, optionB) =>
                  optionA?.children?.toLowerCase().localeCompare(optionB?.children?.toLowerCase())
                }
                onKeyDown={(e) => tabSelectEvent(e, posList, 'pos')}
              >
                {posList.map((value: any) => (
                  <Option key={value.Code} value={JSON.stringify(value)}>
                    {value.Code}
                  </Option>
                ))}
              </Select>
            </FloatLabel>

            {['19', '21', '22', '24'].includes(pos.RmiCode) || (cptDataSource.find(e => OBG_CPTCODES.includes(e.cptCode)) && pos.RmiCode === '11') && facilityList && facilityList.length > 0 ? (
              <>
              <Title level={5}>
                Select a Facility <span style={{color: 'red'}}>*</span>
              </Title>
              <Form.Item
                name="facilitySelect"
                validateTrigger={['onSubmit']}
                rules={[
                  () => ({
                    async validator(_: any, __: any) {
                      if (Object.values(facility).length === 0 && (pos.RmiCode === '11' && cptDataSource.find(e => OBG_CPTCODES.includes(e.cptCode))) ||
                          (Object.values(facility).length === 0 && ['21', '22', '24'].includes(pos.RmiCode)))
                        return Promise.reject(new Error('Facility is required for POS 11, 21, 22, 24. Please select a facility.'));
                      if (Object.values(facility).length === 0 && posType !== 'Tertiary Care')
                        return Promise.reject(new Error('Facility is required for POS 21, 22, 24 or pregnancy. Please select a facility.'));
                      return Promise.resolve();
                    }
                  })
                ]}
                style={{ marginTop: '-40px' }}
                >
                  <div></div>
                {/*adding div helps scroll to error  */}
              </Form.Item>
              {facility && facility.LastName ? (
                <div className="row">
                  <div className={`col-lg-2 ${styles['btn-wrapper']} d-flex justify-content-center align-content-center`}>
                    <Button
                      type="primary"
                      style={{ background: "red", borderColor: 'red' }}
                      onClick={() => setFacility({})}
                    >
                      <DeleteOutlined />
                    </Button>
                  </div>
                  <div className="col-lg-22 mb-2">
                    {facility.LastName}
                    <br />
                    {facility.LastName === 'OTHER HOSPITAL' ? (
                      <>
                        <FloatLabel
                          label="Other Facility Name"
                          form={form}
                          name={"otherFac"}
                          required
                        >
                          <Input />
                        </FloatLabel>
                      </>
                    ) : (
                      <>
                        {facility.Street}
                        <br />
                        {facility.City} {facility.Phone}
                      </>
                    )}
                  </div>
                </div>
              ) : null}
              <div style={{
                height: 250,
                overflow: 'auto',
                padding: '0 16px',
                border: '1px solid rgba(140, 140, 140, 0.35)',
                marginBottom: '20px'
              }}>
                <List
                  itemLayout="horizontal"
                  dataSource={facilityList}
                  loading={props.isFetchingFacilities}
                  renderItem={item => (
                    <List.Item>
                      <a onClick={() => changeFacility(item)}>{item.LastName}</a>
                      <br />
                      {item.Street}
                      <br />
                      {item.City} {item.Phone}
                    </List.Item>
                  )}
                />
              </div>
              </>
            ) : null }

            <div className="row">
              <div className="col-lg-24 col-md-4">
                <FloatLabel
                  label="Enter Diagnosis Min 1, Max 10"
                  name="diagCodeText"
                  form={form}
                  rules={[
                    () => ({
                      async validator(_: any, __: any) {
                        if (diagDataSource && diagDataSource.length !== 0) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Please enter at least 1 diagnosis.'));
                      },
                    })
                  ]}
                  star
                >
                  <AutoComplete
                    id="diag-code"
                    style={{ width: '100%' }}
                    onSearch={debounce(handleDiagCodeSearch, 500)}
                    onSelect={handleSelectDiagCode}
                    notFoundContent={'Not found. Please type more than 3 characters or try your search again.'}
                    defaultActiveFirstOption={true}
                    onKeyDown={(e) => tabSelectEvent(e, diagCodeResult, 'diag-code')}
                    clearIcon
                >
                  {props.isFetchingDiagCodes ? <Option value=""><Spin /></Option> : diagCodeResult.map((value: any) => (
                    <Option key={value.diagcode} value={JSON.stringify(value)}>
                      {value.diagcode}
                    </Option>
                  ))}
                </AutoComplete>
                </FloatLabel>
                {(diagDataSource.length !== 0 &&
                  <Table
                    columns={diagColumns}
                    dataSource={diagDataSource}
                    pagination={false}
                    rowKey={"RmiDiagCode"}
                  />
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-7 col-md-7">
                <FloatLabel
                  label="Enter CPT Code"
                  name="cptCode"
                  form={form}
                  rules={[
                    () => ({
                      async validator(_: any, value: any) {
                        if ((cptDataSource && cptDataSource.length !== 0 && isSubmitting) || (value && !isSubmitting)) {
                          return Promise.resolve();
                        }

                        return Promise.reject(new Error('Please enter at least 1 CPT Code.'));
                      },
                    })
                  ]}
                  star
                >
                <AutoComplete
                  id="cpt-code"
                  style={{ width: '100%' }}
                  onSearch={debounce(handleCPTCodeSearch, 500)}
                  onSelect={handleCPTCodeSelect}
                  disabled={diagDataSource.length === 0 || !provider || (provider && Object.keys(provider).length === 0) || (referralType.RmiReferralType === 'RA' && !retroDos)}
                  notFoundContent={'Not found. Please type more than 2 characters or try your search again.'}
                  defaultActiveFirstOption={true}
                  onKeyDown={(e) => tabSelectEvent(e, CPTCodesResult, 'cpt-code')}
                  allowClear
                >
                  {props.isFetchingCPTCodes ? <Option value=""><Spin /></Option> : CPTCodesResult.map((value: any) => (
                    <Option key={value.RmiProcCode} value={JSON.stringify(value)}>
                      {value.ServiceCode}
                    </Option>
                  ))}
                </AutoComplete>
                </FloatLabel>
              </div>
              <div className="col-lg-4 col-md-4">
                <FloatLabel
                  label="Modifier"
                  name="modifier"
                  form={form}
                  value={modifier}
                >
                <AutoComplete
                  id="modifier"
                  style={{ width: '100%' }}
                  onSelect={(value: string) => { setModifier(JSON.parse(value)); form.setFieldsValue({ modifier: JSON.parse(value).RmiCodeDesc }); }}
                  value={modifier.RmiCodeDesc}
                  filterOption={(inputValue, option: any) =>
                    option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                  onChange={(value) => setModifier(value)}
                  disabled={diagDataSource.length === 0 || !provider || (provider && Object.keys(provider).length === 0)}
                  defaultActiveFirstOption={true}
                  onKeyDown={(e) => tabSelectEvent(e, modifierCodes, 'modifier')}
                  clearIcon
                >
                  {modifierCodes.map((value: any) => (
                    <Option key={value.RmiCodeDesc} value={JSON.stringify(value)}>
                      {value.RmiCodeDesc}
                    </Option>
                  ))}
                </AutoComplete>
                </FloatLabel>
                <Form.List name="additionalModifiers">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                        <div className="row mt-3">
                          <div className="col-lg-24 col-md-24">
                            <Space key={key} align={'baseline'}>
                              <Form.Item
                                {...restField}
                                name={[name, 'modifier']}
                                fieldKey={[fieldKey, 'modifier']}
                              >
                                <Select
                                  id={"additional-modifiers" + index}
                                  showSearch
                                  loading={props.isFetchingModifierCodes}
                                  onKeyDown={(e) => tabSelectEvent(e, modifierCodes, "additional-modifiers" + index)}
                                  defaultActiveFirstOption={true}
                                  placeholder={'Modifier ' + (index + 2)}
                                  style={{ width: '10rem' }}
                                  disabled={diagDataSource.length === 0 || !provider || (provider && Object.keys(provider).length === 0)}
                                >
                                  {modifierCodes.map((value: any) => (
                                    <Option key={value.RmiCodeDesc} value={JSON.stringify(value)}>
                                      {value.RmiCodeDesc}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>

                              <CloseOutlined onClick={() => remove(name)} />
                            </Space>
                          </div>
                        </div>
                      ))}

                      {fields.length < 3 ? (
                        <Form.Item>
                          <Button className="mt-3" type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Add Modifier
                          </Button>
                        </Form.Item>
                      ) : null }
                    </>
                  )}
              </Form.List>
              </div>
              <div className="col-lg-4 col-md-4">
                <FloatLabel
                  label="Diagnosis Code"
                  name="additionalDiags"
                  form={form}
                  rules={[
                    { required: !isSubmitting, message: 'Required' }
                  ]}
                  star
                >
                <Select
                  value={additionalDiags.RmiDiagCode}
                  onChange={value => setAdditionalDiags(JSON.parse(value))}
                  disabled={diagDataSource.length === 0 || !provider || (provider && Object.keys(provider).length === 0)}
                >
                  {diagDataSource.map((value: any, index: number) => (
                    <Option
                      key={value.RmiDiagCode}
                      value={JSON.stringify({ ...value, index, letterIndex: toLetters(index + 1) })}
                    >
                      {value.RmiDiagCode}
                    </Option>
                  ))}
                </Select>
                </FloatLabel>
              </div>
              <div className={diagDataSource.length !== 0 && (provider && Object.keys(provider).length !== 0) && (rXFormVisible || jCodeCount > 0) ? "col-lg-2 col-md-2" : "col-lg-5 col-md-5"}>
                <FloatLabel
                  label="Days/Units"
                  name="units"
                  form={form}
                  rules={[
                    { required: !isSubmitting, message: 'Required' },
                    () => ({
                      async validator(_: any, value: string) {
                        //regex to check if value > 0 and has only up to two decimal places
                        if (value && (isNaN(parseInt(value)) || !value.toString().match(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/) || parseFloat(value) > 9999.99)) {
                          return Promise.reject(new Error('Enter valid value (0-9999.99)'));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                  star
                >
                <Input
                  type="number"
                  disabled={diagDataSource.length === 0 || !provider || (provider && Object.keys(provider).length === 0)}
                />
                </FloatLabel>
              </div>
              <div className={diagDataSource.length !== 0 && (provider && Object.keys(provider).length !== 0) && (rXFormVisible || jCodeCount > 0) ? `col-lg-2 col-md-2 ${styles['btn-wrapper']}` : `col-lg-4 col-md-4 ${styles['btn-wrapper']}`}>
                <Button
                  type='primary'
                  onClick={() => addCptCode()}
                  disabled={diagDataSource.length === 0 || !provider || (provider && Object.keys(provider).length === 0)}
                  style={{
                    width: '100%',
                  }}
                >
                  Add
                </Button>
              </div>

              {diagDataSource.length !== 0 && (provider && Object.keys(provider).length !== 0) && (rXFormVisible || jCodeCount > 0) && (
                <div className="col-lg-5 col-md-5 d-flex align-items-center">
                  {rXFormVisible && (
                    downloadableForms.map(val => {
                      if (val.RmiFileDesc === 'MedicoRX Prescription Request Form') {
                        return <a href='#/' onClick={() => downloadPDF(val.RmiLocationPath + val.RmiFileName)}>Download {val.RmiFileDesc}</a>;
                      }
                    })
                  )}
                  {jCodeCount > 0 && (
                    downloadableForms.map(val => {
                      if (val.RmiFileDesc === "Prescription Drug Prior Authorization Form") {
                        return <a href='#/' onClick={() => downloadPDF(val.RmiLocationPath + val.RmiFileName)}>Download Prescription Drug Form</a>;
                      }
                    })
                  )}
                </div>
              )}
            </div>

            {(cptDataSource.length !== 0 &&
              <Table
                columns={cptColumns}
                dataSource={cptDataSource}
                pagination={false}
                rowKey={"cptCode"}
              />
            )}

            {(CPSPVisible && cptDataSource.find(e => OBG_CPTCODES.includes(e.cptCode)) ) ? (
              <>
              <div className="row">
                <div className="col-lg-24">
                  <br />

                  <Form.Item
                    label="Are you a CPSP certified provider?"
                    labelCol={{ span: 24 }}
                    name="CPSPCertifiedProvider"
                    rules={[
                      { required: true, message: 'Required' }
                    ]}
                  >
                    <Radio.Group
                      onChange={handleCPSPCertifiedProvider}
                      value={CPSPCertifiedProvider}
                    >
                      <Radio value={true}>Yes</Radio>
                      <Radio value={false}>No</Radio>
                    </Radio.Group>
                  </Form.Item>
                  <br />
                </div>
              </div>
              </>
            ) : null }

            {CPSPCertifiedProvider && cptDataSource.find(e => OBG_CPTCODES.includes(e.cptCode)) ? (
              <>
              <div className="row">
                <div className="col-lg-24">
                  <Form.Item
                    label="Have you offered Comprehensive Perinatal Services Program (CPSP) to the member?"
                    labelCol={{ span: 24 }}
                    name="CPSP"
                    rules={[
                      { required: true, message: 'Required' }
                    ]}
                  >
                    <Radio.Group
                      onChange={handleCPSP}
                      value={CPSP}
                    >
                      <Radio value={"A"}>Member Accepted</Radio>
                      <Radio value={"R"}>Member Rejected</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>

              <label>Pregnant members must provide the last menstrual period date</label>
              <div className="row mt-4">
                <div className="col-lg-8">
                  <FloatLabel
                    label="Enter Last Menstrual Period Date"
                    name={'menstrualDate'}
                    value={menstrualDate}
                    form={form}
                    rules={[
                      () => ({
                        async validator(_: any, __: any) {
                          if (!menstrualDate) return Promise.reject(new Error('Required'));
                          if (!moment(menstrualDate).isValid()) return Promise.reject(new Error('Must be in a correct date format'))
                          if (moment(menstrualDate).isAfter(moment().endOf('day'))) return Promise.reject(new Error('Cannot be a future date.'));
                          return Promise.resolve();
                        },
                      })
                    ]}
                    star
                  >
                    <DatePickerLocalised
                      date={menstrualDate}
                      setDate={(date: any) => { setMenstrualDate(date); setDueDate(moment(date).add('9', 'months').format('MM/DD/YYYY')); }}
                      disabledDate={current => current > moment().endOf('day')}
                    />
                  </FloatLabel>
                </div>
                <div className="col-lg-8">
                  <FloatLabel
                    label="Enter Estimated Due Date"
                    value={dueDate}
                    name={'dueDate'}
                    form={form}
                    rules={[
                      () => ({
                        async validator(_: any, __: any) {
                          if (dueDate && !moment(dueDate).isValid()) return Promise.reject(new Error('Must be in a correct date format'))
                          return Promise.resolve();
                        },
                      })
                    ]}
                  >
                    <DatePickerLocalised
                      date={dueDate}
                      setDate={setDueDate}
                    />
                  </FloatLabel>
                </div>
              </div>
            </>
            ) : null }

            <div className="row">
              <div className="col-lg-24 col-md-4">
                <Form.Item
                  label="Symptoms and Treatments"
                  labelCol={{ span: 24 }}
                  name="symptomTreatment"
                  rules={[
                    { required: true, message: 'Required.' },
                    () => ({
                      async validator(_: any, value: any) {
                        if (value && totalOBCare && value.length < 10) {
                          return Promise.reject(new Error('Please enter at least 10 characters.'));
                        }
                        if ( !value || value.length > 4) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Please enter at least 5 characters.'));
                      },
                    }),
                  ]}
                >
                  <TextArea rows={4} />
                </Form.Item>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-24 col-md-4">
                <FloatLabel
                  label="Contact Information"
                  name="contactInformation"
                  form={form}
                >
                  <TextArea rows={4} />
                </FloatLabel>

              </div>
            </div>
          </Form>
        </Card>

        <div className="col-lg-24 col-md-24 mt-2 mb-5">
          <CreateAuthDetailModal
            fileList={attachmentList}
            setFileList={setAttachmentList}
            originalFileNames={originalFileNames}
          />
        </div>

        {props.authDetailState ? (
          <div className="col-lg-24 col-md-24 mt-2 mb-3 ml-2">
            <Title level={4}>Original attachments and approval letters for - (original auth # {props.previousAuthNumber}).</Title>

            Attachment:
            <ul className="pl-4" style={{listStyle: "none"}}>
              {props.authDetailState.attachments && props.authDetailState.attachments.map((data: attachmentData) => {
                return (
                  <>
                    <li>
                      <a
                        onClick={() => downloadAttachment(data)}
                      >
                        {data.fileMeta}
                      </a>
                    </li>
                  </>
                );
              })}
            </ul>

            <br /><br />Notifications:<br />
            <ul className="pl-4" style={{listStyle: "none"}}>
              {props.authDetailState.letterInfos && props.authDetailState.letterInfos.map((data: letterInfosData) => {
                if (data.fileName?.indexOf('PROVIDER_APPROVAL') === -1) return;
                return (
                  <>
                    <li>
                      <span>{moment(data.fileDate).format("MMM D, YYYY [at] h:mmA")}</span>
                      &nbsp; - &nbsp;
                      <a onClick={() => data.fileLocation === "AYCE" ? downloadPDF(`${data.fileLocation}\\${data.fileName}`)
                        : downloadPDF(data.fileLocation + data.fileName)}>
                        {data.fileName}
                      </a>
                    </li>
                  </>
                );
              })}
            </ul>
          </div>
        ) : null }

        <div className="col-lg-24 col-md-24 mt-2">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: '25px',
            marginBottom: '10px',
            width: '100%',
          }}>
            <Button
              type="primary"
              style={{
                width: '100%'
              }}
              onClick={onSubmitValidation}
              loading={props.isSubmitting || props.isFetchingProviderName || props.isFetchingPOS}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingProviderName: store.rootReducer.authProvider.isFetchingName,
  isFetchingPOS: store.rootReducer.authPOS.isFetching,
  isFetchingDiagCodes: store.rootReducer.authDiagCodes.isFetching,
  isFetchingCPTCodes: store.rootReducer.claimCPTCodes.isFetching,
  isFetchingSpecCodes: store.rootReducer.authHistory.isFetching,
  isFetchingReferTypes: store.rootReducer.authReferType.isFetching,
  isFetchingCityList: store.rootReducer.authCity.isFetchingList,
  isFetchingProviderList: store.rootReducer.authProvider.isFetchingWithCity,
  isFetchingFacilities: store.rootReducer.authFacilities.isFetching,
  isFetchingModifierCodes: store.rootReducer.authModifierCode.isFetching,
  isFetchingTempAuthNumber: store.rootReducer.authTempAuthNumber.isFetching,
  isSubmitting: store.rootReducer.authConfirmed.isPosting,
  isFetchingIpaAdvise: store.rootReducer.authProvider.isFetchingIpaAdvise,
  isFetchingExpiryDays: store.rootReducer.authExpiryDays.isFetching,
  isCheckingPCP: store.rootReducer.authProvider.isFetchingPCP,
  isCheckingArcadia: store.rootReducer.authProvider.isFetchingArc,
  isCheckingMedicalCode: store.rootReducer.authMediCal.isCheckingCode,
  isCheckingBenefitRestriction: store.rootReducer.authMediCal.isCheckingBenefit,
  isCheckingAttachmentRequired: store.rootReducer.authAttach.isChecking,
  isFetchingRuleCodes: store.rootReducer.authRuleCodes.isFetching,
  isFetchingConditionCodes: store.rootReducer.eligibility.isFetchingCodes,
  isFetchingOBCodes: store.rootReducer.authOBCodes.isFetching,
  isCheckingInitialFollowUp: store.rootReducer.authProvider.isCheckingFollowUp,
  isAcknowledging: store.rootReducer.authProvider.isPostingAck,
  isFetchingPMTProv: store.rootReducer.authPMTProv.isFetching,
  isPostingAuthHistory: store.rootReducer.authHistory.isPosting,
  isPostingPainMgmt: store.rootReducer.authPMTProv.isPosting,
  isFetchingCECProviders: store.rootReducer.authProvider.isFetchingCECProviders,
  isFetchingResources: store.rootReducer.app.isFetchingResources,
  isDownloadingResources: store.rootReducer.app.isFetchingFile,
  isUploading: store.rootReducer.authFiles.isUploading,
  isFetchingProviderByName: store.rootReducer.authProvider.isFetchingWithName,
  isCheckingSpecialistAuthHistory: store.rootReducer.authSpecialists.isChecking,
  isValidatingOPTOPH: store.rootReducer.authSpecialists.isValidatingOPTOPH,
  validationResult: store.rootReducer.authSpecialists.validationResult,
  priorAuthValidation: store.rootReducer.authMember.isValidatingAuth,
  isGettingProvTermDate: store.rootReducer.authProvider.isGettingProvTermDate,
  isDownloadingAttachment: store.rootReducer.authAttach.isDownloading,
  isFetchingAuth: store.rootReducer.authPortal.isFetching, // fetch authorization detail modal content
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    expireAuth,
    getProviderName,
    getPos,
    getDiagCodes,
    enquireService,
    getSpecCodeList,
    getReferType,
    getProviderByCity,
    getFacilities,
    getAuthModifierCode,
    getTempAuthNumber,
    submitConfirmedAuth,
    getIpaAdvise,
    getExpiryDays,
    isPcp,
    isArcadia,
    checkMediCalCode,
    checkMediCalBenefitRestrict,
    isAttachmentRequired,
    getRuleCodes,
    getMemberConditionCodes,
    getOBCodes,
    checkInitialFollowUp,
    acknowledgement,
    getPMTProv,
    postAuthHistory,
    postPainManagement,
    validatePulmNoduleAndPainClinic,
    validateDuplicateAuth,
    getCECProviders,
    getDownloadableResources,
    downloadResources,
    uploadFilestoAuth,
    getProviderByName,
    checkSpecialistAuthHistory,
    downloadAttachment,
    priorAuthValidation,
    postCPSP,
    getProviderTermDate,
    validateOPTOPH,
    checkProviderForAuthSubmission,
    getPortalAuth,
    getAttachInfo,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(CreateAuthorizationDetail);